(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
    typeof define === 'function' && define.amd ? define(['exports'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.agnosticViewNav = {}));
}(this, (function (exports) { 'use strict';

    function noop() { }
    const identity = x => x;
    function run(fn) {
        return fn();
    }
    function blank_object() {
        return Object.create(null);
    }
    function run_all(fns) {
        fns.forEach(run);
    }
    function is_function(thing) {
        return typeof thing === 'function';
    }
    function safe_not_equal(a, b) {
        return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
    }
    function is_empty(obj) {
        return Object.keys(obj).length === 0;
    }
    function action_destroyer(action_result) {
        return action_result && is_function(action_result.destroy) ? action_result.destroy : noop;
    }

    const is_client = typeof window !== 'undefined';
    let now = is_client
        ? () => window.performance.now()
        : () => Date.now();
    let raf = is_client ? cb => requestAnimationFrame(cb) : noop;

    const tasks = new Set();
    function run_tasks(now) {
        tasks.forEach(task => {
            if (!task.c(now)) {
                tasks.delete(task);
                task.f();
            }
        });
        if (tasks.size !== 0)
            raf(run_tasks);
    }
    /**
     * Creates a new task that runs on each raf frame
     * until it returns a falsy value or is aborted
     */
    function loop(callback) {
        let task;
        if (tasks.size === 0)
            raf(run_tasks);
        return {
            promise: new Promise(fulfill => {
                tasks.add(task = { c: callback, f: fulfill });
            }),
            abort() {
                tasks.delete(task);
            }
        };
    }

    function append(target, node) {
        target.appendChild(node);
    }
    function insert(target, node, anchor) {
        target.insertBefore(node, anchor || null);
    }
    function detach(node) {
        node.parentNode.removeChild(node);
    }
    function element(name) {
        return document.createElement(name);
    }
    function text(data) {
        return document.createTextNode(data);
    }
    function space() {
        return text(' ');
    }
    function empty() {
        return text('');
    }
    function listen(node, event, handler, options) {
        node.addEventListener(event, handler, options);
        return () => node.removeEventListener(event, handler, options);
    }
    function attr(node, attribute, value) {
        if (value == null)
            node.removeAttribute(attribute);
        else if (node.getAttribute(attribute) !== value)
            node.setAttribute(attribute, value);
    }
    function children(element) {
        return Array.from(element.childNodes);
    }
    function set_data(text, data) {
        data = '' + data;
        if (text.wholeText !== data)
            text.data = data;
    }
    function toggle_class(element, name, toggle) {
        element.classList[toggle ? 'add' : 'remove'](name);
    }
    function custom_event(type, detail) {
        const e = document.createEvent('CustomEvent');
        e.initCustomEvent(type, false, false, detail);
        return e;
    }
    class HtmlTag {
        constructor(anchor = null) {
            this.a = anchor;
            this.e = this.n = null;
        }
        m(html, target, anchor = null) {
            if (!this.e) {
                this.e = element(target.nodeName);
                this.t = target;
                this.h(html);
            }
            this.i(anchor);
        }
        h(html) {
            this.e.innerHTML = html;
            this.n = Array.from(this.e.childNodes);
        }
        i(anchor) {
            for (let i = 0; i < this.n.length; i += 1) {
                insert(this.t, this.n[i], anchor);
            }
        }
        p(html) {
            this.d();
            this.h(html);
            this.i(this.a);
        }
        d() {
            this.n.forEach(detach);
        }
    }

    const active_docs = new Set();
    let active = 0;
    // https://github.com/darkskyapp/string-hash/blob/master/index.js
    function hash(str) {
        let hash = 5381;
        let i = str.length;
        while (i--)
            hash = ((hash << 5) - hash) ^ str.charCodeAt(i);
        return hash >>> 0;
    }
    function create_rule(node, a, b, duration, delay, ease, fn, uid = 0) {
        const step = 16.666 / duration;
        let keyframes = '{\n';
        for (let p = 0; p <= 1; p += step) {
            const t = a + (b - a) * ease(p);
            keyframes += p * 100 + `%{${fn(t, 1 - t)}}\n`;
        }
        const rule = keyframes + `100% {${fn(b, 1 - b)}}\n}`;
        const name = `__svelte_${hash(rule)}_${uid}`;
        const doc = node.ownerDocument;
        active_docs.add(doc);
        const stylesheet = doc.__svelte_stylesheet || (doc.__svelte_stylesheet = doc.head.appendChild(element('style')).sheet);
        const current_rules = doc.__svelte_rules || (doc.__svelte_rules = {});
        if (!current_rules[name]) {
            current_rules[name] = true;
            stylesheet.insertRule(`@keyframes ${name} ${rule}`, stylesheet.cssRules.length);
        }
        const animation = node.style.animation || '';
        node.style.animation = `${animation ? `${animation}, ` : ''}${name} ${duration}ms linear ${delay}ms 1 both`;
        active += 1;
        return name;
    }
    function delete_rule(node, name) {
        const previous = (node.style.animation || '').split(', ');
        const next = previous.filter(name
            ? anim => anim.indexOf(name) < 0 // remove specific animation
            : anim => anim.indexOf('__svelte') === -1 // remove all Svelte animations
        );
        const deleted = previous.length - next.length;
        if (deleted) {
            node.style.animation = next.join(', ');
            active -= deleted;
            if (!active)
                clear_rules();
        }
    }
    function clear_rules() {
        raf(() => {
            if (active)
                return;
            active_docs.forEach(doc => {
                const stylesheet = doc.__svelte_stylesheet;
                let i = stylesheet.cssRules.length;
                while (i--)
                    stylesheet.deleteRule(i);
                doc.__svelte_rules = {};
            });
            active_docs.clear();
        });
    }

    let current_component;
    function set_current_component(component) {
        current_component = component;
    }
    function get_current_component() {
        if (!current_component)
            throw new Error('Function called outside component initialization');
        return current_component;
    }
    function beforeUpdate(fn) {
        get_current_component().$$.before_update.push(fn);
    }
    function onMount(fn) {
        get_current_component().$$.on_mount.push(fn);
    }
    function onDestroy(fn) {
        get_current_component().$$.on_destroy.push(fn);
    }
    function createEventDispatcher() {
        const component = get_current_component();
        return (type, detail) => {
            const callbacks = component.$$.callbacks[type];
            if (callbacks) {
                // TODO are there situations where events could be dispatched
                // in a server (non-DOM) environment?
                const event = custom_event(type, detail);
                callbacks.slice().forEach(fn => {
                    fn.call(component, event);
                });
            }
        };
    }

    const dirty_components = [];
    const binding_callbacks = [];
    const render_callbacks = [];
    const flush_callbacks = [];
    const resolved_promise = Promise.resolve();
    let update_scheduled = false;
    function schedule_update() {
        if (!update_scheduled) {
            update_scheduled = true;
            resolved_promise.then(flush);
        }
    }
    function add_render_callback(fn) {
        render_callbacks.push(fn);
    }
    function add_flush_callback(fn) {
        flush_callbacks.push(fn);
    }
    let flushing = false;
    const seen_callbacks = new Set();
    function flush() {
        if (flushing)
            return;
        flushing = true;
        do {
            // first, call beforeUpdate functions
            // and update components
            for (let i = 0; i < dirty_components.length; i += 1) {
                const component = dirty_components[i];
                set_current_component(component);
                update(component.$$);
            }
            set_current_component(null);
            dirty_components.length = 0;
            while (binding_callbacks.length)
                binding_callbacks.pop()();
            // then, once components are updated, call
            // afterUpdate functions. This may cause
            // subsequent updates...
            for (let i = 0; i < render_callbacks.length; i += 1) {
                const callback = render_callbacks[i];
                if (!seen_callbacks.has(callback)) {
                    // ...so guard against infinite loops
                    seen_callbacks.add(callback);
                    callback();
                }
            }
            render_callbacks.length = 0;
        } while (dirty_components.length);
        while (flush_callbacks.length) {
            flush_callbacks.pop()();
        }
        update_scheduled = false;
        flushing = false;
        seen_callbacks.clear();
    }
    function update($$) {
        if ($$.fragment !== null) {
            $$.update();
            run_all($$.before_update);
            const dirty = $$.dirty;
            $$.dirty = [-1];
            $$.fragment && $$.fragment.p($$.ctx, dirty);
            $$.after_update.forEach(add_render_callback);
        }
    }

    let promise;
    function wait() {
        if (!promise) {
            promise = Promise.resolve();
            promise.then(() => {
                promise = null;
            });
        }
        return promise;
    }
    function dispatch(node, direction, kind) {
        node.dispatchEvent(custom_event(`${direction ? 'intro' : 'outro'}${kind}`));
    }
    const outroing = new Set();
    let outros;
    function group_outros() {
        outros = {
            r: 0,
            c: [],
            p: outros // parent group
        };
    }
    function check_outros() {
        if (!outros.r) {
            run_all(outros.c);
        }
        outros = outros.p;
    }
    function transition_in(block, local) {
        if (block && block.i) {
            outroing.delete(block);
            block.i(local);
        }
    }
    function transition_out(block, local, detach, callback) {
        if (block && block.o) {
            if (outroing.has(block))
                return;
            outroing.add(block);
            outros.c.push(() => {
                outroing.delete(block);
                if (callback) {
                    if (detach)
                        block.d(1);
                    callback();
                }
            });
            block.o(local);
        }
    }
    const null_transition = { duration: 0 };
    function create_bidirectional_transition(node, fn, params, intro) {
        let config = fn(node, params);
        let t = intro ? 0 : 1;
        let running_program = null;
        let pending_program = null;
        let animation_name = null;
        function clear_animation() {
            if (animation_name)
                delete_rule(node, animation_name);
        }
        function init(program, duration) {
            const d = program.b - t;
            duration *= Math.abs(d);
            return {
                a: t,
                b: program.b,
                d,
                duration,
                start: program.start,
                end: program.start + duration,
                group: program.group
            };
        }
        function go(b) {
            const { delay = 0, duration = 300, easing = identity, tick = noop, css } = config || null_transition;
            const program = {
                start: now() + delay,
                b
            };
            if (!b) {
                // @ts-ignore todo: improve typings
                program.group = outros;
                outros.r += 1;
            }
            if (running_program || pending_program) {
                pending_program = program;
            }
            else {
                // if this is an intro, and there's a delay, we need to do
                // an initial tick and/or apply CSS animation immediately
                if (css) {
                    clear_animation();
                    animation_name = create_rule(node, t, b, duration, delay, easing, css);
                }
                if (b)
                    tick(0, 1);
                running_program = init(program, duration);
                add_render_callback(() => dispatch(node, b, 'start'));
                loop(now => {
                    if (pending_program && now > pending_program.start) {
                        running_program = init(pending_program, duration);
                        pending_program = null;
                        dispatch(node, running_program.b, 'start');
                        if (css) {
                            clear_animation();
                            animation_name = create_rule(node, t, running_program.b, running_program.duration, 0, easing, config.css);
                        }
                    }
                    if (running_program) {
                        if (now >= running_program.end) {
                            tick(t = running_program.b, 1 - t);
                            dispatch(node, running_program.b, 'end');
                            if (!pending_program) {
                                // we're done
                                if (running_program.b) {
                                    // intro — we can tidy up immediately
                                    clear_animation();
                                }
                                else {
                                    // outro — needs to be coordinated
                                    if (!--running_program.group.r)
                                        run_all(running_program.group.c);
                                }
                            }
                            running_program = null;
                        }
                        else if (now >= running_program.start) {
                            const p = now - running_program.start;
                            t = running_program.a + running_program.d * easing(p / running_program.duration);
                            tick(t, 1 - t);
                        }
                    }
                    return !!(running_program || pending_program);
                });
            }
        }
        return {
            run(b) {
                if (is_function(config)) {
                    wait().then(() => {
                        // @ts-ignore
                        config = config();
                        go(b);
                    });
                }
                else {
                    go(b);
                }
            },
            end() {
                clear_animation();
                running_program = pending_program = null;
            }
        };
    }

    function destroy_block(block, lookup) {
        block.d(1);
        lookup.delete(block.key);
    }
    function outro_and_destroy_block(block, lookup) {
        transition_out(block, 1, 1, () => {
            lookup.delete(block.key);
        });
    }
    function update_keyed_each(old_blocks, dirty, get_key, dynamic, ctx, list, lookup, node, destroy, create_each_block, next, get_context) {
        let o = old_blocks.length;
        let n = list.length;
        let i = o;
        const old_indexes = {};
        while (i--)
            old_indexes[old_blocks[i].key] = i;
        const new_blocks = [];
        const new_lookup = new Map();
        const deltas = new Map();
        i = n;
        while (i--) {
            const child_ctx = get_context(ctx, list, i);
            const key = get_key(child_ctx);
            let block = lookup.get(key);
            if (!block) {
                block = create_each_block(key, child_ctx);
                block.c();
            }
            else if (dynamic) {
                block.p(child_ctx, dirty);
            }
            new_lookup.set(key, new_blocks[i] = block);
            if (key in old_indexes)
                deltas.set(key, Math.abs(i - old_indexes[key]));
        }
        const will_move = new Set();
        const did_move = new Set();
        function insert(block) {
            transition_in(block, 1);
            block.m(node, next);
            lookup.set(block.key, block);
            next = block.first;
            n--;
        }
        while (o && n) {
            const new_block = new_blocks[n - 1];
            const old_block = old_blocks[o - 1];
            const new_key = new_block.key;
            const old_key = old_block.key;
            if (new_block === old_block) {
                // do nothing
                next = new_block.first;
                o--;
                n--;
            }
            else if (!new_lookup.has(old_key)) {
                // remove old block
                destroy(old_block, lookup);
                o--;
            }
            else if (!lookup.has(new_key) || will_move.has(new_key)) {
                insert(new_block);
            }
            else if (did_move.has(old_key)) {
                o--;
            }
            else if (deltas.get(new_key) > deltas.get(old_key)) {
                did_move.add(new_key);
                insert(new_block);
            }
            else {
                will_move.add(old_key);
                o--;
            }
        }
        while (o--) {
            const old_block = old_blocks[o];
            if (!new_lookup.has(old_block.key))
                destroy(old_block, lookup);
        }
        while (n)
            insert(new_blocks[n - 1]);
        return new_blocks;
    }

    function bind(component, name, callback) {
        const index = component.$$.props[name];
        if (index !== undefined) {
            component.$$.bound[index] = callback;
            callback(component.$$.ctx[index]);
        }
    }
    function create_component(block) {
        block && block.c();
    }
    function mount_component(component, target, anchor, customElement) {
        const { fragment, on_mount, on_destroy, after_update } = component.$$;
        fragment && fragment.m(target, anchor);
        if (!customElement) {
            // onMount happens before the initial afterUpdate
            add_render_callback(() => {
                const new_on_destroy = on_mount.map(run).filter(is_function);
                if (on_destroy) {
                    on_destroy.push(...new_on_destroy);
                }
                else {
                    // Edge case - component was destroyed immediately,
                    // most likely as a result of a binding initialising
                    run_all(new_on_destroy);
                }
                component.$$.on_mount = [];
            });
        }
        after_update.forEach(add_render_callback);
    }
    function destroy_component(component, detaching) {
        const $$ = component.$$;
        if ($$.fragment !== null) {
            run_all($$.on_destroy);
            $$.fragment && $$.fragment.d(detaching);
            // TODO null out other refs, including component.$$ (but need to
            // preserve final state?)
            $$.on_destroy = $$.fragment = null;
            $$.ctx = [];
        }
    }
    function make_dirty(component, i) {
        if (component.$$.dirty[0] === -1) {
            dirty_components.push(component);
            schedule_update();
            component.$$.dirty.fill(0);
        }
        component.$$.dirty[(i / 31) | 0] |= (1 << (i % 31));
    }
    function init(component, options, instance, create_fragment, not_equal, props, dirty = [-1]) {
        const parent_component = current_component;
        set_current_component(component);
        const $$ = component.$$ = {
            fragment: null,
            ctx: null,
            // state
            props,
            update: noop,
            not_equal,
            bound: blank_object(),
            // lifecycle
            on_mount: [],
            on_destroy: [],
            on_disconnect: [],
            before_update: [],
            after_update: [],
            context: new Map(parent_component ? parent_component.$$.context : options.context || []),
            // everything else
            callbacks: blank_object(),
            dirty,
            skip_bound: false
        };
        let ready = false;
        $$.ctx = instance
            ? instance(component, options.props || {}, (i, ret, ...rest) => {
                const value = rest.length ? rest[0] : ret;
                if ($$.ctx && not_equal($$.ctx[i], $$.ctx[i] = value)) {
                    if (!$$.skip_bound && $$.bound[i])
                        $$.bound[i](value);
                    if (ready)
                        make_dirty(component, i);
                }
                return ret;
            })
            : [];
        $$.update();
        ready = true;
        run_all($$.before_update);
        // `false` as a special case of no DOM component
        $$.fragment = create_fragment ? create_fragment($$.ctx) : false;
        if (options.target) {
            if (options.hydrate) {
                const nodes = children(options.target);
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.l(nodes);
                nodes.forEach(detach);
            }
            else {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                $$.fragment && $$.fragment.c();
            }
            if (options.intro)
                transition_in(component.$$.fragment);
            mount_component(component, options.target, options.anchor, options.customElement);
            flush();
        }
        set_current_component(parent_component);
    }
    /**
     * Base class for Svelte components. Used when dev=false.
     */
    class SvelteComponent {
        $destroy() {
            destroy_component(this, 1);
            this.$destroy = noop;
        }
        $on(type, callback) {
            const callbacks = (this.$$.callbacks[type] || (this.$$.callbacks[type] = []));
            callbacks.push(callback);
            return () => {
                const index = callbacks.indexOf(callback);
                if (index !== -1)
                    callbacks.splice(index, 1);
            };
        }
        $set($$props) {
            if (this.$$set && !is_empty($$props)) {
                this.$$.skip_bound = true;
                this.$$set($$props);
                this.$$.skip_bound = false;
            }
        }
    }

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

    var freeGlobal$1 = freeGlobal;

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal$1 || freeSelf || Function('return this')();

    var root$1 = root;

    /** Built-in value references. */
    var Symbol$1 = root$1.Symbol;

    var Symbol$2 = Symbol$1;

    /** Used for built-in method references. */
    var objectProto$5 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$4 = objectProto$5.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString$1 = objectProto$5.toString;

    /** Built-in value references. */
    var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty$4.call(value, symToStringTag$1),
          tag = value[symToStringTag$1];

      try {
        value[symToStringTag$1] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString$1.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag$1] = tag;
        } else {
          delete value[symToStringTag$1];
        }
      }
      return result;
    }

    /** Used for built-in method references. */
    var objectProto$4 = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto$4.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
        undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /** `Object#toString` result references. */
    var asyncTag = '[object AsyncFunction]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        proxyTag = '[object Proxy]';

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /** Used to detect overreaching core-js shims. */
    var coreJsData = root$1['__core-js_shared__'];

    var coreJsData$1 = coreJsData;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /** Used for built-in method references. */
    var funcProto$1 = Function.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString$1 = funcProto$1.toString;

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString$1.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used for built-in method references. */
    var funcProto = Function.prototype,
        objectProto$3 = Object.prototype;

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty$3 = objectProto$3.hasOwnProperty;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty$3).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined : object[key];
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    var defineProperty$1 = defineProperty;

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty$1) {
        defineProperty$1(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /** Used for built-in method references. */
    var objectProto$2 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$2 = objectProto$2.hasOwnProperty;

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty$2.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    var isArray$1 = isArray;

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /** `Object#toString` result references. */
    var symbolTag = '[object Symbol]';

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/;

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray$1(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /* Built-in method references that are verified to be native. */
    var nativeCreate = getNative(Object, 'create');

    var nativeCreate$1 = nativeCreate;

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

    /** Used for built-in method references. */
    var objectProto$1 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty$1 = objectProto$1.hasOwnProperty;

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate$1) {
        var result = data[key];
        return result === HASH_UNDEFINED$1 ? undefined : result;
      }
      return hasOwnProperty$1.call(data, key) ? data[key] : undefined;
    }

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /** Used for built-in method references. */
    var arrayProto = Array.prototype;

    /** Built-in value references. */
    var splice = arrayProto.splice;

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /* Built-in method references that are verified to be native. */
    var Map$1 = getNative(root$1, 'Map');

    var Map$2 = Map$1;

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map$2 || ListCache),
        'string': new Hash
      };
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /** Error message constants. */
    var FUNC_ERROR_TEXT = 'Expected a function';

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE = 500;

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /** Used to match property names within property paths. */
    var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    var stringToPath$1 = stringToPath;

    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array == null ? 0 : array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /** Used as references for various `Number` constants. */
    var INFINITY$1 = 1 / 0;

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray$1(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray$1(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath$1(toString(value));
    }

    /** Used as references for various `Number` constants. */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0;

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    function cubicOut$1(t) {
      var f = t - 1.0;
      return f * f * f + 1.0
    }

    function cubicOut(t) {
        const f = t - 1.0;
        return f * f * f + 1.0;
    }

    function slide(node, { delay = 0, duration = 400, easing = cubicOut } = {}) {
        const style = getComputedStyle(node);
        const opacity = +style.opacity;
        const height = parseFloat(style.height);
        const padding_top = parseFloat(style.paddingTop);
        const padding_bottom = parseFloat(style.paddingBottom);
        const margin_top = parseFloat(style.marginTop);
        const margin_bottom = parseFloat(style.marginBottom);
        const border_top_width = parseFloat(style.borderTopWidth);
        const border_bottom_width = parseFloat(style.borderBottomWidth);
        return {
            delay,
            duration,
            easing,
            css: t => 'overflow: hidden;' +
                `opacity: ${Math.min(t * 20, 1) * opacity};` +
                `height: ${t * height}px;` +
                `padding-top: ${t * padding_top}px;` +
                `padding-bottom: ${t * padding_bottom}px;` +
                `margin-top: ${t * margin_top}px;` +
                `margin-bottom: ${t * margin_bottom}px;` +
                `border-top-width: ${t * border_top_width}px;` +
                `border-bottom-width: ${t * border_bottom_width}px;`
        };
    }

    var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

    function createCommonjsModule(fn, basedir, module) {
    	return module = {
    		path: basedir,
    		exports: {},
    		require: function (path, base) {
    			return commonjsRequire(path, (base === undefined || base === null) ? module.path : base);
    		}
    	}, fn(module, module.exports), module.exports;
    }

    function getAugmentedNamespace(n) {
    	if (n.__esModule) return n;
    	var a = Object.defineProperty({}, '__esModule', {value: true});
    	Object.keys(n).forEach(function (k) {
    		var d = Object.getOwnPropertyDescriptor(n, k);
    		Object.defineProperty(a, k, d.get ? d : {
    			enumerable: true,
    			get: function () {
    				return n[k];
    			}
    		});
    	});
    	return a;
    }

    function commonjsRequire () {
    	throw new Error('Dynamic requires are not currently supported by @rollup/plugin-commonjs');
    }

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    var __createBinding = Object.create ? (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
    }) : (function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });

    function __exportStar(m, o) {
        for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }
    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    }
    var __setModuleDefault = Object.create ? (function(o, v) {
        Object.defineProperty(o, "default", { enumerable: true, value: v });
    }) : function(o, v) {
        o["default"] = v;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
        __setModuleDefault(result, mod);
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var tslib_es6 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        __extends: __extends,
        get __assign () { return __assign; },
        __rest: __rest,
        __decorate: __decorate,
        __param: __param,
        __metadata: __metadata,
        __awaiter: __awaiter,
        __generator: __generator,
        __createBinding: __createBinding,
        __exportStar: __exportStar,
        __values: __values,
        __read: __read,
        __spread: __spread,
        __spreadArrays: __spreadArrays,
        __await: __await,
        __asyncGenerator: __asyncGenerator,
        __asyncDelegator: __asyncDelegator,
        __asyncValues: __asyncValues,
        __makeTemplateObject: __makeTemplateObject,
        __importStar: __importStar,
        __importDefault: __importDefault,
        __classPrivateFieldGet: __classPrivateFieldGet,
        __classPrivateFieldSet: __classPrivateFieldSet
    });

    var Cache_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    /**
     * Simple cache implementation
     */
    var Cache = /** @class */ (function () {
        function Cache() {
            this.data = {};
            this.pending = {};
        }
        Cache.prototype.put = function (key, value) {
            var previousValue = this.data[key];
            this.data[key] = value;
            return previousValue;
        };
        Cache.prototype.get = function (key) {
            return this.data[key];
        };
        Cache.prototype.remove = function (key) {
            var previousValue = this.data[key];
            delete this.data[key];
            return previousValue;
        };
        Cache.prototype.removeAll = function () {
            this.data = {};
        };
        /**
         * Gets a value from the cache or invokes the callback to populate the value
         * with the result of a promise. If invoked multiple times, it will return the promise
         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
         *
         * @param key cache key
         * @param callback returns a Promise to populate the cache with
         * @returns Promise<*> a promise with the cached value
         */
        Cache.prototype.refreshIfAbsent = function (key, callback) {
            if (this.data.hasOwnProperty(key)) {
                return Promise.resolve(this.data[key]);
            }
            return this.refresh(key, callback);
        };
        /**
         * Invokes the callback to populate the value with the result of a promise.
         * If invoked multiple times, it will return the promise
         * of the first pending invocation, preventing multiple invocations while a promise is resolving.
         *
         * @param key cache key
         * @param callback returns a Promise to populate the cache with
         * @returns Promise<*> a promise with the cached value
         */
        Cache.prototype.refresh = function (key, callback) {
            var _this = this;
            // Check if the callback is already pending for this key
            var pending = this.pending[key];
            if (pending) {
                return pending;
            }
            pending = callback();
            this.pending[key] = pending;
            return pending.then(function (value) {
                delete _this.pending[key];
                _this.put(key, value);
                return value;
            }).catch(function (error) {
                delete _this.pending[key];
                throw error;
            });
        };
        return Cache;
    }());
    exports.default = Cache;

    });

    var tslib_1 = /*@__PURE__*/getAugmentedNamespace(tslib_es6);

    var Registry_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.SERVICE_REGISTRY_PATH = void 0;

    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
    exports.SERVICE_REGISTRY_PATH = '/api/portal/v2/client/config';
    var PORTAL_SERVICE_NAME = 'portal_service';
    var PORTAL_CLIENT_CONFIG_PATH = 'client/config';
    var DEFAULT_CONFIG = {
        host: '',
        cache: new Cache_1$1.default(),
    };
    var Registry = /** @class */ (function () {
        function Registry(config) {
            if (config === void 0) { config = DEFAULT_CONFIG; }
            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
        }
        // Get the underlying registry cache
        Registry.prototype.getCache = function () {
            return this.config.cache;
        };
        Registry.prototype.getRegistry = function () {
            var _this = this;
            return this.config.cache.refreshIfAbsent('registry', function () {
                var serviceRegistryUrl = _this.getHost();
                serviceRegistryUrl += exports.SERVICE_REGISTRY_PATH;
                var config = {
                    method: 'GET',
                    mode: 'cors',
                    credentials: 'include',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                };
                return fetch(serviceRegistryUrl, config).then(function (resp) {
                    if (!resp.ok) {
                        return Promise.reject(resp);
                    }
                    return resp.json().then(function (data) {
                        var dataResponse = tslib_1.__assign({ data: data }, resp);
                        var registry = data.registry;
                        // Optimization - also stuff the client config URL into the cache.
                        // Sometimes, this URL can be different if it's requested from the same domain.
                        var portalService = registry.services[PORTAL_SERVICE_NAME];
                        if (portalService) {
                            var clientConfigUrl = _this.createServiceUrl(portalService, PORTAL_CLIENT_CONFIG_PATH, 2);
                            _this.config.cache.put(clientConfigUrl, dataResponse);
                        }
                        return dataResponse;
                    });
                });
            }).then(function (resp) {
                return resp.data.registry;
            });
        };
        Registry.prototype.getUrl = function (serviceName, path, version) {
            var _this = this;
            if (path === void 0) { path = ''; }
            return this.getRegistry().then(function (data) {
                var service = data.services[serviceName];
                if (service === undefined) {
                    throw new Error("Unable to find service '" + serviceName + "'");
                }
                return service;
            }).then(function (service) {
                return _this.createServiceUrl(service, path, version);
            });
        };
        Registry.prototype.getServiceBaseUrl = function (service, version) {
            var baseUrl = service.base_sv_url;
            if (!baseUrl) {
                // unversioned service - simply return regular service url
                return service.sv_url;
            }
            if (version === undefined) {
                // Use configured version if present
                // if(apiVersions[serviceName]) {
                //  version = apiVersions[serviceName];
                // Fallback to version 1 (keeps backwards comparability and generally safe)
                version = 1;
            }
            return this.joinUrlParts(baseUrl, 'v' + version);
        };
        Registry.prototype.getServiceHostUrl = function (service) {
            // Inspired by https://gist.github.com/jlong/2428561
            var parser = document.createElement('a');
            parser.href = service.sv_url;
            return parser.protocol + "//" + parser.host;
        };
        Registry.prototype.createServiceUrl = function (service, path, version) {
            var base;
            if (path.charAt(0) === '/') {
                // Host absolute URL
                base = this.getServiceHostUrl(service);
            }
            else {
                // Service relative URL
                base = this.getServiceBaseUrl(service, version);
            }
            return this.joinUrlParts(base, path);
        };
        /**
         * Determines the registry host in the following order,
         * 1. Uses the configured host if set
         * 2. If a PrintOS subdomain is detected as the current hostname,
         *    the base domain is returned.
         *    For example, if location.hostname is 'app.www.printos.com',
         *    then 'www.printos.com' is returned.
         * 3. Return an empty string otherwise (resulting in a registry call relative
         *    to the current host).
         */
        Registry.prototype.getHost = function () {
            if (this.config.host) {
                // Ensure https
                if (this.config.host.indexOf('https://') !== 0) {
                    this.config.host = 'https://' + this.config.host;
                }
                return this.config.host;
            }
            return '';
        };
        Registry.prototype.joinUrlParts = function (a, b) {
            if (!b) {
                return a;
            }
            if (b.charAt(0) === '/') {
                // Prevent double slashes by ensuring part b doesn't have a slash
                b = b.substr(1);
            }
            if (a.charAt(a.length - 1) === '/') {
                return a + b;
            }
            return a + '/' + b;
        };
        return Registry;
    }());
    exports.default = Registry;

    });

    var Http_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", { value: true });

    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
    var DEFAULT_CONFIG = {
        registry: new Registry_1$1.default(),
    };
    var Http = /** @class */ (function () {
        function Http(config) {
            if (config === void 0) { config = DEFAULT_CONFIG; }
            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
            // Use registry cache by default to cache the registry efficiently
            this.config.cache = this.config.cache || this.config.registry.getCache();
        }
        Http.prototype.getCookie = function (name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length == 2) {
                return decodeURIComponent(parts.pop().split(';').shift());
            }
        };
        Http.prototype.fetchJsonResponse = function (config) {
            var _this = this;
            var url = Http.formatUrl(config);
            var fetchConfig = {
                method: config.method,
                mode: config.mode ? config.mode : 'cors',
                credentials: config.credentials ? config.credentials : 'include',
                headers: {},
            };
            // if (fetchConfig.credentials === 'include') {
            //   fetchConfig.headers['Access-Control-Allow-Origin'] = '*';
            //   fetchConfig.headers['Access-Control-Allow-Methods'] = 'GET, POST, PUT, DELETE, OPTIONS';
            //   fetchConfig.headers['Access-Control-Allow-Headers'] = 'Content-Type, Authorization, X-Requested-With';
            //   fetchConfig.headers['Access-Control-Allow-Credentials'] = true;
            // }
            if (config.data !== undefined && config.data !== null) {
                if (config.data instanceof FormData) {
                    fetchConfig.body = config.data;
                    // fetchConfig.headers['Content-Type'] = undefined;
                    fetchConfig.headers['Accept'] = '*/*';
                }
                else {
                    fetchConfig.body = config.data instanceof Object ? JSON.stringify(config.data) : config.data;
                    fetchConfig.headers['Accept'] = 'application/json, text/plain, */*';
                    fetchConfig.headers['Content-Type'] = 'application/json';
                    // XSRF-TOKEN handling
                    var xsrfToken = this.getCookie('XSRF-TOKEN');
                    if (xsrfToken) {
                        fetchConfig.headers['X-XSRF-TOKEN'] = xsrfToken;
                    }
                }
            }
            // Add or overwrite any headers that were passed in
            fetchConfig.headers = tslib_1.__assign(tslib_1.__assign({}, fetchConfig.headers), (config.headers ? config.headers : {}));
            // Clean up any undefined or null values from the object if explicitly set
            for (var _i = 0, _a = Object.entries(fetchConfig.headers); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (value === undefined || value === null) {
                    delete fetchConfig.headers[key];
                }
            }
            return fetch(url, fetchConfig).then(function (resp) {
                if (_this.responseInterceptor) {
                    return _this.responseInterceptor(resp);
                }
                return resp;
            }).then(function (resp) {
                if (!resp.ok) {
                    if (resp.headers.get('Content-Type').includes('application/json')) {
                        return resp.json().then(function (data) {
                            // Extend response to include data
                            return Promise.reject(Object.assign(resp, { data: data }));
                        });
                    }
                    if (resp.headers.get('Content-Type').includes('text/plain')) {
                        return resp.text().then(function (data) {
                            // Extend response to include data
                            return Promise.reject(Object.assign(resp, { data: data }));
                        });
                    }
                    return Promise.reject(Object.assign(resp, { data: null }));
                }
                if (resp.status === 204) {
                    return Promise.resolve(Object.assign(resp, { data: null }));
                }
                if (fetchConfig.method === 'HEAD') {
                    return Promise.resolve(Object.assign(resp, { data: null }));
                }
                var contentType = resp.headers.get('Content-Type');
                if (contentType.includes('application/json')) {
                    return resp.json().then(function (data) {
                        // Extend response to include data
                        return Object.assign(resp, { data: data });
                    });
                }
                if (contentType.includes('text/plain') || config.responseType === 'text') {
                    return resp.text().then(function (data) {
                        // Extend response to include data
                        return Object.assign(resp, { data: data });
                    });
                }
                return Promise.resolve(Object.assign(resp));
            });
        };
        Http.formatUrl = function (config) {
            var url = config.url;
            if (config.params) {
                if (url.includes('?')) {
                    url += '&';
                }
                else {
                    url += '?';
                }
                url += Http.getQueryString(config.params);
            }
            return url;
        };
        // Adapted from https://github.com/github/fetch/issues/256#issuecomment-271870897
        Http.getQueryString = function (params) {
            return Object.keys(params).map(function (k) {
                var param = params[k];
                if (Array.isArray(param)) {
                    return param
                        .map(function (val) { return encodeURIComponent(k) + "=" + encodeURIComponent(val); })
                        .join('&');
                }
                return encodeURIComponent(k) + "=" + encodeURIComponent(param);
            }).join('&');
        };
        Http.prototype.request = function (config) {
            var _this = this;
            if (config === void 0) { config = {}; }
            if (config.cache === true) {
                return this.config.cache.refreshIfAbsent(Http.formatUrl(config), function () {
                    return _this.fetchJsonResponse(config);
                });
            }
            if (config.cache === 'refresh') {
                return this.config.cache.refresh(Http.formatUrl(config), function () {
                    return _this.fetchJsonResponse(config);
                });
            }
            return this.fetchJsonResponse(config);
        };
        Http.prototype.serviceRequest = function (serviceName, path, config) {
            var _this = this;
            if (config === void 0) { config = {}; }
            return this.config.registry.getUrl(serviceName, path, config.version).then(function (url) {
                config.url = url;
                return _this.request(config);
            });
        };
        //
        // Shortcut methods
        //
        Http.prototype.get = function (serviceName, path, config) {
            if (config === void 0) { config = {}; }
            config.method = 'GET';
            return this.serviceRequest(serviceName, path, config);
        };
        Http.prototype.post = function (serviceName, path, data, config) {
            if (config === void 0) { config = {}; }
            config.method = 'POST';
            config.data = data;
            return this.serviceRequest(serviceName, path, config);
        };
        Http.prototype.put = function (serviceName, path, data, config) {
            if (config === void 0) { config = {}; }
            config.method = 'PUT';
            config.data = data;
            return this.serviceRequest(serviceName, path, config);
        };
        Http.prototype.patch = function (serviceName, path, data, config) {
            if (config === void 0) { config = {}; }
            config.method = 'PATCH';
            config.data = data;
            return this.serviceRequest(serviceName, path, config);
        };
        Http.prototype.delete = function (serviceName, path, config) {
            if (config === void 0) { config = {}; }
            config.method = 'DELETE';
            return this.serviceRequest(serviceName, path, config);
        };
        Http.prototype.head = function (serviceName, path, config) {
            if (config === void 0) { config = {}; }
            config.method = 'HEAD';
            return this.serviceRequest(serviceName, path, config);
        };
        Http.prototype.fetch = function (url, config) {
            if (config === void 0) { config = {}; }
            config.url = url;
            return this.fetchJsonResponse(config);
        };
        return Http;
    }());
    exports.default = Http;

    });

    var Preferences_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", { value: true });

    var Http_1$1 = tslib_1.__importDefault(Http_1);
    var DEFAULT_CONFIG = {
        http: new Http_1$1.default(),
    };
    var Preferences = /** @class */ (function () {
        function Preferences(config) {
            if (config === void 0) { config = DEFAULT_CONFIG; }
            this.config = tslib_1.__assign(tslib_1.__assign({}, DEFAULT_CONFIG), config);
        }
        Preferences.prototype.get = function (path, cache) {
            if (path === void 0) { path = null; }
            if (cache === void 0) { cache = true; }
            var reqPath = 'preferences';
            if (path) {
                reqPath += '/' + path;
            }
            return this.config.http.get('portal_service', reqPath, { version: 2, cache: cache }).then(function (resp) {
                return resp.data;
            });
        };
        Preferences.prototype.update = function (prefs) {
            return this.config.http.put('portal_service', 'preferences', prefs, { version: 2 }).then(function (resp) {
                return resp.data;
            });
        };
        Preferences.prototype.patch = function (path, prefs) {
            return this.config.http.patch('portal_service', "preferences/" + path, prefs, { version: 2 }).then(function (resp) {
                return resp.data;
            });
        };
        Preferences.prototype.delete = function (path) {
            return this.config.http.delete('portal_service', "preferences/" + path, { version: 2 }).then(function (resp) {
                return resp.data;
            });
        };
        Preferences.prototype.deleteAll = function () {
            return this.config.http.delete('portal_service', 'preferences', { version: 2 });
        };
        return Preferences;
    }());
    exports.default = Preferences;

    });

    var Locale_1 = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    var Locale = /** @class */ (function () {
        function Locale() {
            this.LOCALE_COOKIE_NAME = 'pos.rn.locale';
        }
        Locale.prototype.getCookieValue = function (cookieName) {
            var match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
            if (match) {
                return decodeURIComponent(match[2]);
            }
            return null;
        };
        Locale.prototype.getBestFit = function () {
            var cookie = JSON.parse(this.getCookieValue(this.LOCALE_COOKIE_NAME));
            if (cookie && cookie.locale) {
                return cookie.locale.split('-')[0];
            }
            return window.navigator.language.split('-')[0];
        };
        return Locale;
    }());
    exports.default = Locale;

    });

    var dist = createCommonjsModule(function (module, exports) {
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.locale = exports.preferences = exports.http = exports.registry = exports.cache = void 0;

    var Cache_1$1 = tslib_1.__importDefault(Cache_1);
    var Registry_1$1 = tslib_1.__importDefault(Registry_1);
    var Http_1$1 = tslib_1.__importDefault(Http_1);
    var Preferences_1$1 = tslib_1.__importDefault(Preferences_1);
    var Locale_1$1 = tslib_1.__importDefault(Locale_1);
    // TODO: move into Registry and have it listen for blue ready
    function getRegistryHost() {
        var host = '';
        if (window.printos &&
            window.printos.blue &&
            window.printos.blue.ui &&
            window.printos.blue.ui.registry) {
            host = window.printos.blue.ui.registry.host;
        }
        return host;
    }
    exports.cache = new Cache_1$1.default();
    exports.registry = new Registry_1$1.default({
        cache: exports.cache,
        host: getRegistryHost(),
    });
    exports.http = new Http_1$1.default({
        cache: exports.cache,
        registry: exports.registry
    });
    exports.preferences = new Preferences_1$1.default({ http: exports.http });
    exports.locale = new Locale_1$1.default();
    exports.default = {
        cache: exports.cache,
        registry: exports.registry,
        http: exports.http,
        preferences: exports.preferences,
        locale: exports.locale,
    };

    });

    createCommonjsModule(function (module, exports) {
    (function (global, factory) {
      factory(exports) ;
    }(commonjsGlobal, (function (exports) {
      function _classCallCheck(a, n) {
        if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
      }
      function _defineProperties(e, r) {
        for (var t = 0; t < r.length; t++) {
          var o = r[t];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
        }
      }
      function _createClass(e, r, t) {
        return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
          writable: !1
        }), e;
      }
      function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
          var i = e.call(t, r || "default");
          if ("object" != typeof i) return i;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
      }
      function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
      }

      function styleInject(css, ref) {
        if ( ref === void 0 ) ref = {};
        var insertAt = ref.insertAt;

        if (!css || typeof document === 'undefined') { return; }

        var head = document.head || document.getElementsByTagName('head')[0];
        var style = document.createElement('style');
        style.type = 'text/css';

        if (insertAt === 'top') {
          if (head.firstChild) {
            head.insertBefore(style, head.firstChild);
          } else {
            head.appendChild(style);
          }
        } else {
          head.appendChild(style);
        }

        if (style.styleSheet) {
          style.styleSheet.cssText = css;
        } else {
          style.appendChild(document.createTextNode(css));
        }
      }

      var css_248z = "[pros-tooltip]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}pros-tooltip-overlay{background-color:#5a5a5a;color:#fff;width:auto;border-radius:4px;padding:4px 8px;margin-top:4px;transform:translateX(-50%);z-index:1000001;font-family:FormaDJR,sans-serif;font-size:12px;font-weight:500;text-align:center;white-space:nowrap;pointer-events:none;user-select:none}pros-tooltip-overlay,pros-tooltip-overlay *,pros-tooltip-overlay :after,pros-tooltip-overlay :before{box-sizing:border-box}pros-tooltip-overlay.pros-custom-tooltip{padding:0;overflow:hidden}";
      styleInject(css_248z);

      var Tooltips = /*#__PURE__*/function () {
        function Tooltips() {
          _classCallCheck(this, Tooltips);
          this._observers = new WeakMap();
          this._listeners = {
            mouseenter: new WeakMap(),
            mouseleave: new WeakMap()
          };
        }
        return _createClass(Tooltips, [{
          key: "addObserver",
          value: function addObserver() {
            var _this = this;
            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
            if (this._observers.get(target)) {
              // Could also throw an error
              return;
            }
            var observer = new MutationObserver(function (mutations) {
              mutations.forEach(function (mutation) {
                if (mutation.type !== 'childList') {
                  return;
                }
                var addedNodes = mutation.addedNodes;
                for (var i = 0; i < addedNodes.length; i++) {
                  var node = addedNodes[i];
                  if (!node.querySelectorAll) {
                    continue;
                  }

                  //Check node itself and then children
                  if (node.hasAttribute('pros-tooltip')) {
                    _this._bind(node);
                  }
                  var elements = node.querySelectorAll('[pros-tooltip]');
                  if (elements.length > 0) {
                    for (var j = 0; j < elements.length; j++) {
                      var element = elements[j];
                      _this._bind(element);
                    }
                  }
                }
                var removedNodes = mutation.removedNodes;
                for (var _i = 0; _i < removedNodes.length; _i++) {
                  var _node = removedNodes[_i];
                  if (!_node.querySelectorAll) {
                    continue;
                  }
                  if (_node.hasAttribute('pros-tooltip')) {
                    _this._unbind(_node);
                  }
                  var _elements = _node.querySelectorAll('[pros-tooltip]');
                  if (_elements.length > 0) {
                    for (var _j = 0; _j < _elements.length; _j++) {
                      var _element = _elements[_j];
                      _this._unbind(_element);
                    }
                  }
                }
              });
            });
            observer.observe(target, {
              childList: true,
              subtree: true,
              attributes: false,
              characterData: false
            });
            this._observers.set(target, observer);
          }
        }, {
          key: "removeObserver",
          value: function removeObserver() {
            var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.body;
            var observer = this._observers.get(target);
            if (observer) {
              observer.disconnect();
              this._observers["delete"](target);
            }
          }
        }, {
          key: "hasTooltipContent",
          value: function hasTooltipContent(value, el) {
            var attributeValue = el.getAttribute('pros-tooltip');
            if (attributeValue) {
              attributeValue = attributeValue.trim();
            }
            var elContent = el.textContent.trim();
            return attributeValue !== '' || elContent !== '';
          }
        }, {
          key: "_bind",
          value: function _bind(el) {
            var _this2 = this;
            var listener = function listener() {
              var attributeValue = el.getAttribute('pros-tooltip');
              if (!_this2.hasTooltipContent(attributeValue, el) || !attributeValue && isFullContentVisible(el)) {
                // not specified and text not truncated - don't show tooltip
                return;
              }
              var tooltipEl = document.createElement('pros-tooltip-overlay');
              setContent(tooltipEl, el);
              setPosition(tooltipEl, el);

              // Hide, then append to get width, then show once width corrected.
              // Approach from http://stackoverflow.com/a/2930159/277307
              hideElement(tooltipEl);
              document.body.appendChild(tooltipEl);
              ensureEvenWidth(tooltipEl);
              ensureNotClipped(tooltipEl);
              showElement(tooltipEl);
              removeOnMouseLeave.call(_this2, tooltipEl, el);
            };
            var enterListener = this._listeners.mouseenter.get(el);
            if (!enterListener) {
              el.addEventListener('mouseenter', listener);
              this._listeners.mouseenter.set(el, listener);
            }
          }
        }, {
          key: "_unbind",
          value: function _unbind(el) {
            var enterListener = this._listeners.mouseenter.get(el);
            if (enterListener) {
              el.removeEventListener('mouseenter', enterListener);
              this._listeners.mouseenter["delete"](el);
            }
            var leaveListener = this._listeners.mouseleave.get(el);
            if (leaveListener) {
              leaveListener.call(this);
            }
          }
        }]);
      }(); // Adapted from http://stackoverflow.com/a/10017343/277307
      function isFullContentVisible(el) {
        return el.offsetWidth >= el.scrollWidth;
      }
      function setPosition(tooltipEl, el) {
        tooltipEl.style.position = 'fixed';
        var elRect = el.getBoundingClientRect();
        tooltipEl.style.top = elRect.top + elRect.height + 'px';
        // Center horizontally under element
        tooltipEl.style.left = elRect.left + elRect.width / 2 + 'px';
        return tooltipEl;
      }
      function setContent(tooltipEl, el) {
        var attrValue = el.getAttribute('pros-tooltip');
        if (attrValue) {
          // Use value if provided
          if (attrValue[0] === '<') {
            tooltipEl.innerHTML = attrValue;
            tooltipEl.style.whiteSpace = 'unset';
            tooltipEl.classList.add('pros-custom-tooltip');
          } else {
            tooltipEl.textContent = attrValue;
          }
        } else {
          // Element text by default
          tooltipEl.textContent = el.textContent;
        }
        return tooltipEl;
      }
      function removeOnMouseLeave(tooltipEl, el) {
        var _this3 = this;
        var _leaveHandler = function leaveHandler() {
          document.body.removeChild(tooltipEl);
          el.removeEventListener('mouseleave', _leaveHandler);
          _this3._listeners.mouseleave["delete"](el);
        };
        el.addEventListener('mouseleave', _leaveHandler);
        this._listeners.mouseleave.set(el, _leaveHandler);
      }
      function hideElement(tooltipEl) {
        tooltipEl.style.visibility = 'hidden';
      }
      function showElement(tooltipEl) {
        tooltipEl.style.removeProperty('visibility');
      }

      // Necessary because of chrome font antialiasing with translations on odd widths
      // will cause blurry text. See http://stackoverflow.com/a/41456864/277307
      function ensureEvenWidth(tooltipEl) {
        var width = Math.round(tooltipEl.getBoundingClientRect().width);
        if (width % 2 !== 0) {
          width++;
          tooltipEl.style.width = width + 'px';
        }
      }
      function ensureNotClipped(tooltipEl) {
        // Ensure not clipped by window boundary,
        // since we're transforming left 50% and width could exceed the window.
        var rect = tooltipEl.getBoundingClientRect();
        var halfWidth = rect.width / 2;
        if (rect.left < 0) {
          tooltipEl.style.left = halfWidth + 'px';
        } else if (rect.right > window.innerWidth) {
          tooltipEl.style.left = window.innerWidth - halfWidth + 'px';
        }
      }

      exports.Tooltips = Tooltips;

      Object.defineProperty(exports, '__esModule', { value: true });

    })));
    });

    /* usr/local/ado-agent/_work/1/s/packages/@printos/agnostic/icon/src/Icon.svelte generated by Svelte v3.38.2 */

    function add_css$1() {
    	var style = element("style");
    	style.id = "svelte-1if0avd-style";
    	style.textContent = ".pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;line-height:unset}.pros-icon-wrapper.svelte-1if0avd .pros-icon-content.svelte-1if0avd svg{width:auto;height:100%}.pros-icon-wrapper[pos--mode=form].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:48px;margin-left:8px;margin-bottom:20px;border-radius:4px}.pros-icon-wrapper[pos--mode=form].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;height:32px;width:32px;border-radius:4px}.pros-icon-wrapper[pos--mode=clickable].svelte-1if0avd .pros-icon-content.svelte-1if0avd{height:24px;width:auto}.pros-icon-wrapper[pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--mode=toolbar].svelte-1if0avd.svelte-1if0avd{cursor:pointer;width:auto;height:16px;margin-left:8px}.pros-icon-wrapper[pos--mode=toolbar].disabled.svelte-1if0avd.svelte-1if0avd{cursor:default}.pros-icon-wrapper[pos--theme=light].svelte-1if0avd.svelte-1if0avd{color:#212121}.pros-icon-wrapper[pos--theme=light].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#212121;background-color:transparent}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=light][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#adadad}.pros-icon-wrapper[pos--theme=light][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}.pros-icon-wrapper[pos--theme=dark].svelte-1if0avd.svelte-1if0avd{color:#ebebeb}.pros-icon-wrapper[pos--theme=dark].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd{color:#ffffff;background-color:transparent}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].svelte-1if0avd.svelte-1if0avd:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-icon-wrapper[pos--theme=dark][pos--mode=clickable].disabled.svelte-1if0avd.svelte-1if0avd{color:#585858}.pros-icon-wrapper[pos--theme=dark][pos--mode=button].svelte-1if0avd.svelte-1if0avd{color:inherit}";
    	append(document.head, style);
    }

    // (3:4) {#if _content}
    function create_if_block$1(ctx) {
    	let html_tag;
    	let html_anchor;

    	return {
    		c() {
    			html_anchor = empty();
    			html_tag = new HtmlTag(html_anchor);
    		},
    		m(target, anchor) {
    			html_tag.m(/*_content*/ ctx[1], target, anchor);
    			insert(target, html_anchor, anchor);
    		},
    		p(ctx, dirty) {
    			if (dirty & /*_content*/ 2) html_tag.p(/*_content*/ ctx[1]);
    		},
    		d(detaching) {
    			if (detaching) detach(html_anchor);
    			if (detaching) html_tag.d();
    		}
    	};
    }

    function create_fragment$1(ctx) {
    	let div1;
    	let div0;
    	let div0_pros_tooltip_value;
    	let div1_class_value;
    	let if_block = /*_content*/ ctx[1] && create_if_block$1(ctx);

    	return {
    		c() {
    			div1 = element("div");
    			div0 = element("div");
    			if (if_block) if_block.c();
    			attr(div0, "class", "pros-icon-content svelte-1if0avd");
    			attr(div0, "style", /*_style*/ ctx[4]);
    			attr(div0, "pros-tooltip", div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null);
    			attr(div1, "class", div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd");
    			attr(div1, "style", /*_style*/ ctx[4]);
    			attr(div1, "pos--theme", /*_theme*/ ctx[2]);
    			attr(div1, "pos--mode", /*mode*/ ctx[0]);
    			toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
    		},
    		m(target, anchor) {
    			insert(target, div1, anchor);
    			append(div1, div0);
    			if (if_block) if_block.m(div0, null);
    			/*div1_binding*/ ctx[22](div1);
    		},
    		p(ctx, [dirty]) {
    			if (/*_content*/ ctx[1]) {
    				if (if_block) {
    					if_block.p(ctx, dirty);
    				} else {
    					if_block = create_if_block$1(ctx);
    					if_block.c();
    					if_block.m(div0, null);
    				}
    			} else if (if_block) {
    				if_block.d(1);
    				if_block = null;
    			}

    			if (dirty & /*_style*/ 16) {
    				attr(div0, "style", /*_style*/ ctx[4]);
    			}

    			if (dirty & /*tooltip*/ 64 && div0_pros_tooltip_value !== (div0_pros_tooltip_value = /*tooltip*/ ctx[6] || null)) {
    				attr(div0, "pros-tooltip", div0_pros_tooltip_value);
    			}

    			if (dirty & /*_className*/ 8 && div1_class_value !== (div1_class_value = "pros-icon-wrapper " + /*_className*/ ctx[3] + " svelte-1if0avd")) {
    				attr(div1, "class", div1_class_value);
    			}

    			if (dirty & /*_style*/ 16) {
    				attr(div1, "style", /*_style*/ ctx[4]);
    			}

    			if (dirty & /*_theme*/ 4) {
    				attr(div1, "pos--theme", /*_theme*/ ctx[2]);
    			}

    			if (dirty & /*mode*/ 1) {
    				attr(div1, "pos--mode", /*mode*/ ctx[0]);
    			}

    			if (dirty & /*_className, disabled*/ 136) {
    				toggle_class(div1, "disabled", /*disabled*/ ctx[7]);
    			}
    		},
    		i: noop,
    		o: noop,
    		d(detaching) {
    			if (detaching) detach(div1);
    			if (if_block) if_block.d();
    			/*div1_binding*/ ctx[22](null);
    		}
    	};
    }

    function hasValue(test) {
    	return test !== undefined && test !== null;
    }

    function instance$1($$self, $$props, $$invalidate) {
    	createEventDispatcher();
    	let { name = null } = $$props; // Name of veneer image (E.G. 'alarm')
    	let { path = null } = $$props; // Path relative to 'https://cdn/printos.com/images' image (E.G. 'veneer/alarm-o.svg')
    	let { url = null } = $$props; // Full url of hosted image (E.G. 'https://cdn.printos.com/images/veneer/alarm-o.svg')
    	let { theme = "auto" } = $$props; // Color Theme (auto/dark/light)
    	let { mode = "default" } = $$props; // default/form
    	let { className = "" } = $$props; // Class name
    	let { tooltip } = $$props;
    	let { disabled = false } = $$props;
    	let { size = "24px" } = $$props;
    	let { constraint = "h" } = $$props;
    	let { color } = $$props;
    	let { solid = false } = $$props;
    	let { _content = undefined } = $$props;
    	let { _theme } = $$props;
    	let { _lastTheme } = $$props;
    	let { _className } = $$props;
    	let { _style = "" } = $$props;
    	let { _iconElement = undefined } = $$props;
    	let { _lastName = null } = $$props;
    	let { _lastPath = null } = $$props;
    	let { _lastUrl = null } = $$props;

    	onMount(() => {
    		$$invalidate(3, _className = hasValue(className) ? className : "");
    		updateContent();
    	}); // setTimeout(() => {_iconElement.parentElement.style.width = 'auto';});

    	beforeUpdate(() => {
    		$$invalidate(8, theme = hasValue(theme) ? theme : "light");
    		$$invalidate(0, mode = hasValue(mode) ? mode : "icon");

    		if (theme !== _lastTheme) {
    			$$invalidate(9, _lastTheme = theme);

    			if (theme === "auto") {
    				let themeAttribute = window.document.body.getAttribute("pos--theme");
    				$$invalidate(2, _theme = themeAttribute ? themeAttribute : "light");
    				window.removeEventListener("posh-theme-changed", handleThemeChanged);
    				window.addEventListener("posh-theme-changed", handleThemeChanged);
    			} else {
    				$$invalidate(2, _theme = theme);
    			}
    		}

    		if (name !== _lastName) {
    			$$invalidate(10, _lastName = name);
    			updateContent();
    		}

    		if (path !== _lastPath) {
    			$$invalidate(11, _lastPath = path);
    			updateContent();
    		}

    		if (url !== _lastUrl) {
    			$$invalidate(12, _lastUrl = url);
    			updateContent();
    		}
    	});

    	onDestroy(() => {
    		window.removeEventListener("posh-theme-changed", handleThemeChanged);
    	});

    	function updateContent() {
    		if (name) {
    			let myName = solid ? name : `${name}-o`;
    			loadContent.call(this, `https://cdn.printos.com/images/general/veneer/${myName}.svg`);
    		} else if (path) {
    			let myPath = path.endsWith(".svg") ? path : `${path}.svg`;
    			loadContent.call(this, `https://cdn.printos.com/images/${myPath}`);
    		} else if (url) {
    			loadContent.call(this, url);
    		}
    	}

    	function handleThemeChanged(event) {
    		if (theme === "auto") {
    			$$invalidate(2, _theme = event.detail.theme);
    		}
    	}

    	// Others
    	function loadContent(url) {
    		let config = {
    			url,
    			cache: true,
    			credentials: "omit",
    			responseType: "text"
    		};

    		return dist.http.request(config).then(resp => {
    			$$invalidate(1, _content = resp.data);
    		});
    	}

    	function div1_binding($$value) {
    		binding_callbacks[$$value ? "unshift" : "push"](() => {
    			_iconElement = $$value;
    			$$invalidate(5, _iconElement);
    		});
    	}

    	$$self.$$set = $$props => {
    		if ("name" in $$props) $$invalidate(13, name = $$props.name);
    		if ("path" in $$props) $$invalidate(14, path = $$props.path);
    		if ("url" in $$props) $$invalidate(15, url = $$props.url);
    		if ("theme" in $$props) $$invalidate(8, theme = $$props.theme);
    		if ("mode" in $$props) $$invalidate(0, mode = $$props.mode);
    		if ("className" in $$props) $$invalidate(16, className = $$props.className);
    		if ("tooltip" in $$props) $$invalidate(6, tooltip = $$props.tooltip);
    		if ("disabled" in $$props) $$invalidate(7, disabled = $$props.disabled);
    		if ("size" in $$props) $$invalidate(17, size = $$props.size);
    		if ("constraint" in $$props) $$invalidate(18, constraint = $$props.constraint);
    		if ("color" in $$props) $$invalidate(19, color = $$props.color);
    		if ("solid" in $$props) $$invalidate(20, solid = $$props.solid);
    		if ("_content" in $$props) $$invalidate(1, _content = $$props._content);
    		if ("_theme" in $$props) $$invalidate(2, _theme = $$props._theme);
    		if ("_lastTheme" in $$props) $$invalidate(9, _lastTheme = $$props._lastTheme);
    		if ("_className" in $$props) $$invalidate(3, _className = $$props._className);
    		if ("_style" in $$props) $$invalidate(4, _style = $$props._style);
    		if ("_iconElement" in $$props) $$invalidate(5, _iconElement = $$props._iconElement);
    		if ("_lastName" in $$props) $$invalidate(10, _lastName = $$props._lastName);
    		if ("_lastPath" in $$props) $$invalidate(11, _lastPath = $$props._lastPath);
    		if ("_lastUrl" in $$props) $$invalidate(12, _lastUrl = $$props._lastUrl);
    	};

    	$$self.$$.update = () => {
    		if ($$self.$$.dirty & /*size, constraint, color, _style*/ 917520) {
    			// onState
    			{
    				if (size) {
    					let h;
    					let w;

    					switch (constraint) {
    						case "b":
    							h = isNaN(size) ? size : `${size}px`;
    							w = isNaN(size) ? size : `${size}px`;
    							break;
    						case "w":
    							w = isNaN(size) ? size : `${size}px`;
    							h = "fit-content";
    							break;
    						case "h":
    						default:
    							h = isNaN(size) ? size : `${size}px`;
    							w = "fit-content";
    							break;
    					}

    					$$invalidate(4, _style = `height:${h};width:${w};`);
    				}

    				if (color) {
    					if (hasValue(color)) {
    						$$invalidate(4, _style += `color:${color};fill:${color}`);
    					}
    				}
    			}
    		}
    	};

    	return [
    		mode,
    		_content,
    		_theme,
    		_className,
    		_style,
    		_iconElement,
    		tooltip,
    		disabled,
    		theme,
    		_lastTheme,
    		_lastName,
    		_lastPath,
    		_lastUrl,
    		name,
    		path,
    		url,
    		className,
    		size,
    		constraint,
    		color,
    		solid,
    		hasValue,
    		div1_binding
    	];
    }

    class Icon extends SvelteComponent {
    	constructor(options) {
    		super();
    		if (!document.getElementById("svelte-1if0avd-style")) add_css$1();

    		init(this, options, instance$1, create_fragment$1, safe_not_equal, {
    			name: 13,
    			path: 14,
    			url: 15,
    			theme: 8,
    			mode: 0,
    			className: 16,
    			tooltip: 6,
    			disabled: 7,
    			size: 17,
    			constraint: 18,
    			color: 19,
    			solid: 20,
    			_content: 1,
    			_theme: 2,
    			_lastTheme: 9,
    			_className: 3,
    			_style: 4,
    			_iconElement: 5,
    			_lastName: 10,
    			_lastPath: 11,
    			_lastUrl: 12,
    			hasValue: 21
    		});
    	}

    	get hasValue() {
    		return hasValue;
    	}
    }

    /* src/ViewNav.svelte generated by Svelte v3.38.2 */
    function add_css() {
      var style = element("style");
      style.id = "svelte-18b46lh-style";
      style.textContent = ".pros-global-wrapper.svelte-18b46lh.svelte-18b46lh{height:100%}.pros-view-nav.svelte-18b46lh.svelte-18b46lh{position:relative;width:60px;height:100%;font-family:FormaDJR, sans-serif;font-size:16px;box-sizing:border-box}.pros-view-nav.hideNav.svelte-18b46lh.svelte-18b46lh{display:none}.pros-view-nav.svelte-18b46lh .view-content-container.svelte-18b46lh{display:flex;flex-direction:column;justify-content:center;align-items:center;height:auto;padding:4px 10px}.pros-view-nav.svelte-18b46lh .pros-view-nav-content.svelte-18b46lh{position:absolute;left:0;top:0;bottom:0;transition:width 0.25s ease-out;z-index:30;overflow:auto;scrollbar-width:thin;border-radius:0 0 12px 0;width:100%}.pros-view-nav.svelte-18b46lh .pros-view-nav-content.expanded.svelte-18b46lh:not(.is-xs){width:250px}.pros-view-nav.svelte-18b46lh svg{fill:currentColor;width:fit-content;max-width:100%;height:100%;pointer-events:none}.pros-view-nav.svelte-18b46lh .view-name-tooltip.svelte-18b46lh{display:none;position:fixed;border-radius:3px;max-width:200px;min-width:100px;padding:8px;left:68px;overflow:hidden;font-size:14px}.pros-view-nav.svelte-18b46lh .view-description.svelte-18b46lh{display:none;position:fixed;border-radius:12px;max-width:240px;padding:8px;left:258px;font-size:14px;overflow:hidden;word-break:break-word;overflow-wrap:anywhere}.pros-view-nav.svelte-18b46lh .view-content.svelte-18b46lh{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;cursor:pointer;flex:1;width:100%;height:40px;border-radius:10px;box-sizing:border-box}.pros-view-nav.svelte-18b46lh .view-content .view-link.svelte-18b46lh{cursor:pointer;display:flex;justify-content:center;align-items:center;width:100%;height:40px;color:inherit;text-decoration:none}.pros-view-nav.svelte-18b46lh .view-content .view-link .view-name.svelte-18b46lh{color:transparent;text-align:left;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;flex:1;width:0;transition:width 0.25s ease-out}.pros-view-nav.svelte-18b46lh .view-content .view-link .view-name.expanded.svelte-18b46lh{margin-left:8px;width:auto;transition:width 0.25s ease-out}.pros-view-nav.svelte-18b46lh .view-content .view-link .view-icon.svelte-18b46lh{height:24px;min-height:24px;width:24px;min-width:24px;line-height:24px;margin:0 8px}.pros-view-nav.svelte-18b46lh .view-content .view-link .no-view-icon.svelte-18b46lh{min-width:24px;height:24px}.pros-view-nav.svelte-18b46lh .view-content .expand-icon.svelte-18b46lh{position:absolute;right:0;height:24px;width:24px;transition:transform 0.5s ease, -webkit-transform 0.5s ease;transform:rotate(180deg)}.pros-view-nav.svelte-18b46lh .view-content .expand-icon.expanded.svelte-18b46lh{transform:rotate(0)}.pros-view-nav.svelte-18b46lh .child-views.svelte-18b46lh{width:100%;min-width:0;font-size:14px;box-sizing:border-box}.pros-view-nav.svelte-18b46lh .child-views .view-content.svelte-18b46lh{padding-left:50px}.pros-view-nav.svelte-18b46lh .svelte-18b46lh::-webkit-scrollbar{width:2px}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .pros-view-nav-content.svelte-18b46lh{background-color:#f8f8f8;box-shadow:4px 12px 20px rgba(33, 33, 33, 0.15);scrollbar-color:#dbdbdb transparent}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .view-name-tooltip.svelte-18b46lh{color:#ffffff;background-color:#2b2b2b;box-shadow:4px 12px 20px rgba(33, 33, 33, 0.15)}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .view-description.svelte-18b46lh{color:#ffffff;background-color:#404040}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .view-content.svelte-18b46lh{color:#737373}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .view-content .view-name.svelte-18b46lh{color:#404040}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .view-content .expand-icon.svelte-18b46lh{color:#404040}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .view-content.svelte-18b46lh:hover{background-color:rgba(33, 33, 33, 0.05)}.pros-global-wrapper[pos--theme=light].svelte-18b46lh .pros-view-nav .view-content.selected.svelte-18b46lh{color:#027aae}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .pros-view-nav-content.svelte-18b46lh{background-color:#2b2b2b;box-shadow:4px 12px 20px rgba(33, 33, 33, 0.15);scrollbar-color:#ebebeb transparent}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .view-name-tooltip.svelte-18b46lh{color:#212121;background-color:#f8f8f8;box-shadow:4px 12px 20px rgba(33, 33, 33, 0.15)}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .view-description.svelte-18b46lh{color:#212121;background-color:#fdfdfd}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .view-content.svelte-18b46lh{color:#adadad}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .view-content .view-name.svelte-18b46lh{color:#ebebeb}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .view-content .expand-icon.svelte-18b46lh{color:#ebebeb}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .view-content.svelte-18b46lh:hover{background-color:#212121}.pros-global-wrapper[pos--theme=dark].svelte-18b46lh .pros-view-nav .view-content.selected.svelte-18b46lh{color:#3ab4eb}";
      append(document.head, style);
    }
    function get_each_context(ctx, list, i) {
      const child_ctx = ctx.slice();
      child_ctx[47] = list[i];
      child_ctx[48] = list;
      child_ctx[49] = i;
      return child_ctx;
    }
    function get_each_context_1(ctx, list, i) {
      const child_ctx = ctx.slice();
      child_ctx[50] = list[i];
      return child_ctx;
    }

    // (2:0) {#if views && views.length > 0}
    function create_if_block(ctx) {
      let div2;
      let div1;
      let div0;
      let each_blocks = [];
      let each_1_lookup = new Map();
      let div0_transition;
      let current;
      let mounted;
      let dispose;
      let each_value = /*views*/ctx[0];
      const get_key = ctx => /*view*/ctx[47].id;
      for (let i = 0; i < each_value.length; i += 1) {
        let child_ctx = get_each_context(ctx, each_value, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
      }
      return {
        c() {
          div2 = element("div");
          div1 = element("div");
          div0 = element("div");
          for (let i = 0; i < each_blocks.length; i += 1) {
            each_blocks[i].c();
          }
          attr(div0, "class", "pros-view-nav-content svelte-18b46lh");
          toggle_class(div0, "expanded", /*menuExpanded*/ctx[2]);
          toggle_class(div0, "responsive-expanded", /*responsiveExpanded*/ctx[6]);
          toggle_class(div0, "is-xs", /*isXS*/ctx[5]);
          attr(div1, "class", "pros-view-nav svelte-18b46lh");
          toggle_class(div1, "is-xs", /*isXS*/ctx[5]);
          toggle_class(div1, "hideNav", /*hideNav*/ctx[12]);
          attr(div2, "class", "pros-global-wrapper svelte-18b46lh");
          attr(div2, "pos--theme", /*_theme*/ctx[9]);
          attr(div2, "pos--shape", /*_shape*/ctx[10]);
          attr(div2, "pos-density", /*_density*/ctx[11]);
        },
        m(target, anchor) {
          insert(target, div2, anchor);
          append(div2, div1);
          append(div1, div0);
          for (let i = 0; i < each_blocks.length; i += 1) {
            each_blocks[i].m(div0, null);
          }
          current = true;
          if (!mounted) {
            dispose = [listen(div0, "mousemove", /*handleMouseOver*/ctx[14]), listen(div0, "mouseleave", /*handleMouseLeave*/ctx[15]), listen(div1, "click", /*expandNav*/ctx[18])];
            mounted = true;
          }
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views, selectedId, selectedParentId, viewClicked, hideTooltips, timeoutId, menuExpanded, showTooltips, isXS, hideAndCollapse, selectedGrandParentId, _theme*/205759) {
            each_value = /*views*/ctx[0];
            group_outros();
            each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div0, outro_and_destroy_block, create_each_block, null, get_each_context);
            check_outros();
          }
          if (dirty[0] & /*menuExpanded*/4) {
            toggle_class(div0, "expanded", /*menuExpanded*/ctx[2]);
          }
          if (dirty[0] & /*responsiveExpanded*/64) {
            toggle_class(div0, "responsive-expanded", /*responsiveExpanded*/ctx[6]);
          }
          if (dirty[0] & /*isXS*/32) {
            toggle_class(div0, "is-xs", /*isXS*/ctx[5]);
          }
          if (dirty[0] & /*isXS*/32) {
            toggle_class(div1, "is-xs", /*isXS*/ctx[5]);
          }
          if (dirty[0] & /*hideNav*/4096) {
            toggle_class(div1, "hideNav", /*hideNav*/ctx[12]);
          }
          if (!current || dirty[0] & /*_theme*/512) {
            attr(div2, "pos--theme", /*_theme*/ctx[9]);
          }
          if (!current || dirty[0] & /*_shape*/1024) {
            attr(div2, "pos--shape", /*_shape*/ctx[10]);
          }
          if (!current || dirty[0] & /*_density*/2048) {
            attr(div2, "pos-density", /*_density*/ctx[11]);
          }
        },
        i(local) {
          if (current) return;
          for (let i = 0; i < each_value.length; i += 1) {
            transition_in(each_blocks[i]);
          }
          add_render_callback(() => {
            if (!div0_transition) div0_transition = create_bidirectional_transition(div0, /*slideRight*/ctx[19], {}, true);
            div0_transition.run(1);
          });
          current = true;
        },
        o(local) {
          for (let i = 0; i < each_blocks.length; i += 1) {
            transition_out(each_blocks[i]);
          }
          if (!div0_transition) div0_transition = create_bidirectional_transition(div0, /*slideRight*/ctx[19], {}, false);
          div0_transition.run(0);
          current = false;
        },
        d(detaching) {
          if (detaching) detach(div2);
          for (let i = 0; i < each_blocks.length; i += 1) {
            each_blocks[i].d();
          }
          if (detaching && div0_transition) div0_transition.end();
          mounted = false;
          run_all(dispose);
        }
      };
    }

    // (18:12) {#if view.icon}
    function create_if_block_9(ctx) {
      let t;
      let if_block1_anchor;
      let current;
      let if_block0 = /*view*/ctx[47].icon.svg && create_if_block_11(ctx);
      let if_block1 = (/*view*/ctx[47].icon.name || /*view*/ctx[47].icon.path || /*view*/ctx[47].icon.url) && create_if_block_10(ctx);
      return {
        c() {
          if (if_block0) if_block0.c();
          t = space();
          if (if_block1) if_block1.c();
          if_block1_anchor = empty();
        },
        m(target, anchor) {
          if (if_block0) if_block0.m(target, anchor);
          insert(target, t, anchor);
          if (if_block1) if_block1.m(target, anchor);
          insert(target, if_block1_anchor, anchor);
          current = true;
        },
        p(ctx, dirty) {
          if (/*view*/ctx[47].icon.svg) {
            if (if_block0) {
              if_block0.p(ctx, dirty);
            } else {
              if_block0 = create_if_block_11(ctx);
              if_block0.c();
              if_block0.m(t.parentNode, t);
            }
          } else if (if_block0) {
            if_block0.d(1);
            if_block0 = null;
          }
          if (/*view*/ctx[47].icon.name || /*view*/ctx[47].icon.path || /*view*/ctx[47].icon.url) {
            if (if_block1) {
              if_block1.p(ctx, dirty);
              if (dirty[0] & /*views*/1) {
                transition_in(if_block1, 1);
              }
            } else {
              if_block1 = create_if_block_10(ctx);
              if_block1.c();
              transition_in(if_block1, 1);
              if_block1.m(if_block1_anchor.parentNode, if_block1_anchor);
            }
          } else if (if_block1) {
            group_outros();
            transition_out(if_block1, 1, 1, () => {
              if_block1 = null;
            });
            check_outros();
          }
        },
        i(local) {
          if (current) return;
          transition_in(if_block1);
          current = true;
        },
        o(local) {
          transition_out(if_block1);
          current = false;
        },
        d(detaching) {
          if (if_block0) if_block0.d(detaching);
          if (detaching) detach(t);
          if (if_block1) if_block1.d(detaching);
          if (detaching) detach(if_block1_anchor);
        }
      };
    }

    // (19:12) {#if view.icon.svg}
    function create_if_block_11(ctx) {
      let div;
      let raw_value = /*view*/ctx[47].icon.svg + "";
      return {
        c() {
          div = element("div");
          attr(div, "class", "view-icon svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
          div.innerHTML = raw_value;
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views*/1 && raw_value !== (raw_value = /*view*/ctx[47].icon.svg + "")) div.innerHTML = raw_value;
        },
        d(detaching) {
          if (detaching) detach(div);
        }
      };
    }

    // (24:12) {#if view.icon.name || view.icon.path || view.icon.url}
    function create_if_block_10(ctx) {
      let div;
      let icon;
      let updating_name;
      let updating_path;
      let updating_url;
      let current;
      function icon_name_binding(value) {
        /*icon_name_binding*/ctx[34](value, /*view*/ctx[47]);
      }
      function icon_path_binding(value) {
        /*icon_path_binding*/ctx[35](value, /*view*/ctx[47]);
      }
      function icon_url_binding(value) {
        /*icon_url_binding*/ctx[36](value, /*view*/ctx[47]);
      }
      let icon_props = {
        size: "24",
        theme: /*_theme*/ctx[9]
      };
      if (/*view*/ctx[47].icon.name !== void 0) {
        icon_props.name = /*view*/ctx[47].icon.name;
      }
      if (/*view*/ctx[47].icon.path !== void 0) {
        icon_props.path = /*view*/ctx[47].icon.path;
      }
      if (/*view*/ctx[47].icon.url !== void 0) {
        icon_props.url = /*view*/ctx[47].icon.url;
      }
      icon = new Icon({
        props: icon_props
      });
      binding_callbacks.push(() => bind(icon, "name", icon_name_binding));
      binding_callbacks.push(() => bind(icon, "path", icon_path_binding));
      binding_callbacks.push(() => bind(icon, "url", icon_url_binding));
      return {
        c() {
          div = element("div");
          create_component(icon.$$.fragment);
          attr(div, "class", "view-icon svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
          mount_component(icon, div, null);
          current = true;
        },
        p(new_ctx, dirty) {
          ctx = new_ctx;
          const icon_changes = {};
          if (dirty[0] & /*_theme*/512) icon_changes.theme = /*_theme*/ctx[9];
          if (!updating_name && dirty[0] & /*views*/1) {
            updating_name = true;
            icon_changes.name = /*view*/ctx[47].icon.name;
            add_flush_callback(() => updating_name = false);
          }
          if (!updating_path && dirty[0] & /*views*/1) {
            updating_path = true;
            icon_changes.path = /*view*/ctx[47].icon.path;
            add_flush_callback(() => updating_path = false);
          }
          if (!updating_url && dirty[0] & /*views*/1) {
            updating_url = true;
            icon_changes.url = /*view*/ctx[47].icon.url;
            add_flush_callback(() => updating_url = false);
          }
          icon.$set(icon_changes);
        },
        i(local) {
          if (current) return;
          transition_in(icon.$$.fragment, local);
          current = true;
        },
        o(local) {
          transition_out(icon.$$.fragment, local);
          current = false;
        },
        d(detaching) {
          if (detaching) detach(div);
          destroy_component(icon);
        }
      };
    }

    // (30:12) {#if !view.icon || !(view.icon.svg || view.icon.name || view.icon.path || view.icon.url)}
    function create_if_block_8(ctx) {
      let div;
      return {
        c() {
          div = element("div");
          attr(div, "class", "no-view-icon svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
        },
        d(detaching) {
          if (detaching) detach(div);
        }
      };
    }

    // (35:10) {#if view.childViews.length > 0 && menuExpanded}
    function create_if_block_7(ctx) {
      let div;
      return {
        c() {
          div = element("div");
          div.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" class="svelte-18b46lh"><path d="M7 14l5-5 5 5z" class="svelte-18b46lh"></path><path d="M0 0h24v24H0z" fill="none" class="svelte-18b46lh"></path></svg>`;
          attr(div, "class", "expand-icon svelte-18b46lh");
          toggle_class(div, "expanded", /*view*/ctx[47].isExpanded);
        },
        m(target, anchor) {
          insert(target, div, anchor);
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views*/1) {
            toggle_class(div, "expanded", /*view*/ctx[47].isExpanded);
          }
        },
        d(detaching) {
          if (detaching) detach(div);
        }
      };
    }

    // (40:10) {#if !menuExpanded && showTooltips && !isXS}
    function create_if_block_6(ctx) {
      let div;
      let t_value = /*view*/ctx[47].name + "";
      let t;
      let positionDescription_action;
      let mounted;
      let dispose;
      return {
        c() {
          div = element("div");
          t = text(t_value);
          attr(div, "class", "view-name-tooltip svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
          append(div, t);
          if (!mounted) {
            dispose = [listen(div, "mouseenter", /*hideTooltips*/ctx[16]), action_destroyer(positionDescription_action = positionDescription.call(null, div))];
            mounted = true;
          }
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views*/1 && t_value !== (t_value = /*view*/ctx[47].name + "")) set_data(t, t_value);
        },
        d(detaching) {
          if (detaching) detach(div);
          mounted = false;
          run_all(dispose);
        }
      };
    }

    // (45:10) {#if menuExpanded && view.description && showTooltips && !isXS}
    function create_if_block_5(ctx) {
      let div;
      let wbr;
      let t_value = /*view*/ctx[47].description + "";
      let t;
      let positionDescription_action;
      let mounted;
      let dispose;
      return {
        c() {
          div = element("div");
          wbr = element("wbr");
          t = text(t_value);
          attr(wbr, "class", "svelte-18b46lh");
          attr(div, "class", "view-description svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
          append(div, wbr);
          append(div, t);
          if (!mounted) {
            dispose = [listen(div, "mouseenter", /*hideAndCollapse*/ctx[17]), action_destroyer(positionDescription_action = positionDescription.call(null, div))];
            mounted = true;
          }
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views*/1 && t_value !== (t_value = /*view*/ctx[47].description + "")) set_data(t, t_value);
        },
        d(detaching) {
          if (detaching) detach(div);
          mounted = false;
          run_all(dispose);
        }
      };
    }

    // (52:8) {#if view.childViews.length > 0 && view.isExpanded}
    function create_if_block_1(ctx) {
      let div;
      let each_blocks = [];
      let each_1_lookup = new Map();
      let div_transition;
      let current;
      let each_value_1 = /*view*/ctx[47].childViews;
      const get_key = ctx => /*childView*/ctx[50].id;
      for (let i = 0; i < each_value_1.length; i += 1) {
        let child_ctx = get_each_context_1(ctx, each_value_1, i);
        let key = get_key(child_ctx);
        each_1_lookup.set(key, each_blocks[i] = create_each_block_1(key, child_ctx));
      }
      return {
        c() {
          div = element("div");
          for (let i = 0; i < each_blocks.length; i += 1) {
            each_blocks[i].c();
          }
          attr(div, "class", "child-views svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
          for (let i = 0; i < each_blocks.length; i += 1) {
            each_blocks[i].m(div, null);
          }
          current = true;
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views, selectedId, selectedParentId, viewClicked, hideTooltips, timeoutId, menuExpanded, showTooltips, isXS, hideAndCollapse*/205231) {
            each_value_1 = /*view*/ctx[47].childViews;
            each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value_1, each_1_lookup, div, destroy_block, create_each_block_1, null, get_each_context_1);
          }
        },
        i(local) {
          if (current) return;
          add_render_callback(() => {
            if (!div_transition) div_transition = create_bidirectional_transition(div, slide, {}, true);
            div_transition.run(1);
          });
          current = true;
        },
        o(local) {
          if (!div_transition) div_transition = create_bidirectional_transition(div, slide, {}, false);
          div_transition.run(0);
          current = false;
        },
        d(detaching) {
          if (detaching) detach(div);
          for (let i = 0; i < each_blocks.length; i += 1) {
            each_blocks[i].d();
          }
          if (detaching && div_transition) div_transition.end();
        }
      };
    }

    // (67:14) {#if childView.description && showTooltips && !isXS}
    function create_if_block_4(ctx) {
      let div;
      let wbr;
      let t_value = /*childView*/ctx[50].description + "";
      let t;
      let mounted;
      let dispose;
      return {
        c() {
          div = element("div");
          wbr = element("wbr");
          t = text(t_value);
          attr(wbr, "class", "svelte-18b46lh");
          attr(div, "class", "view-description svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
          append(div, wbr);
          append(div, t);
          if (!mounted) {
            dispose = [listen(div, "mouseenter", /*hideAndCollapse*/ctx[17]), action_destroyer(positionDescription.call(null, div))];
            mounted = true;
          }
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views*/1 && t_value !== (t_value = /*childView*/ctx[50].description + "")) set_data(t, t_value);
        },
        d(detaching) {
          if (detaching) detach(div);
          mounted = false;
          run_all(dispose);
        }
      };
    }

    // (60:12) {#if !menuExpanded && showTooltips && !isXS}
    function create_if_block_2(ctx) {
      let if_block_anchor;
      let if_block = /*timeoutId*/ctx[7] && create_if_block_3(ctx);
      return {
        c() {
          if (if_block) if_block.c();
          if_block_anchor = empty();
        },
        m(target, anchor) {
          if (if_block) if_block.m(target, anchor);
          insert(target, if_block_anchor, anchor);
        },
        p(ctx, dirty) {
          if (/*timeoutId*/ctx[7]) {
            if (if_block) {
              if_block.p(ctx, dirty);
            } else {
              if_block = create_if_block_3(ctx);
              if_block.c();
              if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
          } else if (if_block) {
            if_block.d(1);
            if_block = null;
          }
        },
        d(detaching) {
          if (if_block) if_block.d(detaching);
          if (detaching) detach(if_block_anchor);
        }
      };
    }

    // (61:14) {#if timeoutId}
    function create_if_block_3(ctx) {
      let div;
      let t_value = /*childView*/ctx[50].name + "";
      let t;
      let positionDescription_action;
      let mounted;
      let dispose;
      return {
        c() {
          div = element("div");
          t = text(t_value);
          attr(div, "class", "view-name-tooltip svelte-18b46lh");
        },
        m(target, anchor) {
          insert(target, div, anchor);
          append(div, t);
          if (!mounted) {
            dispose = [listen(div, "mouseenter", /*hideTooltips*/ctx[16]), action_destroyer(positionDescription_action = positionDescription.call(null, div))];
            mounted = true;
          }
        },
        p(ctx, dirty) {
          if (dirty[0] & /*views*/1 && t_value !== (t_value = /*childView*/ctx[50].name + "")) set_data(t, t_value);
        },
        d(detaching) {
          if (detaching) detach(div);
          mounted = false;
          run_all(dispose);
        }
      };
    }

    // (54:10) {#each view.childViews as childView (childView.id)}
    function create_each_block_1(key_1, ctx) {
      let div2;
      let a;
      let div0;
      let t0_value = /*childView*/ctx[50].name + "";
      let t0;
      let addHref_action;
      let t1;
      let div1;
      let t2;
      let t3;
      let div2_id_value;
      let mounted;
      let dispose;
      function select_block_type(ctx, dirty) {
        if (! /*menuExpanded*/ctx[2] && /*showTooltips*/ctx[8] && ! /*isXS*/ctx[5]) return create_if_block_2;
        if (/*childView*/ctx[50].description && /*showTooltips*/ctx[8] && ! /*isXS*/ctx[5]) return create_if_block_4;
      }
      let current_block_type = select_block_type(ctx);
      let if_block = current_block_type && current_block_type(ctx);
      function click_handler_1(...args) {
        return /*click_handler_1*/ctx[38](/*childView*/ctx[50], ...args);
      }
      return {
        key: key_1,
        first: null,
        c() {
          div2 = element("div");
          a = element("a");
          div0 = element("div");
          t0 = text(t0_value);
          t1 = space();
          div1 = element("div");
          t2 = space();
          if (if_block) if_block.c();
          t3 = space();
          attr(div0, "pros-tooltip", "");
          attr(div0, "class", "view-name svelte-18b46lh");
          attr(a, "class", "view-link svelte-18b46lh");
          attr(div1, "class", "selected-indicator svelte-18b46lh");
          attr(div2, "id", div2_id_value = "view-" + /*childView*/ctx[50].id);
          attr(div2, "class", "view-content svelte-18b46lh");
          toggle_class(div2, "selected", /*childView*/ctx[50].id === /*selectedId*/ctx[1] || /*childView*/ctx[50].id === /*selectedParentId*/ctx[3]);
          this.first = div2;
        },
        m(target, anchor) {
          insert(target, div2, anchor);
          append(div2, a);
          append(a, div0);
          append(div0, t0);
          append(div2, t1);
          append(div2, div1);
          append(div2, t2);
          if (if_block) if_block.m(div2, null);
          append(div2, t3);
          if (!mounted) {
            dispose = [action_destroyer(addHref_action = addHref.call(null, a, /*childView*/ctx[50].href)), listen(div2, "click", click_handler_1)];
            mounted = true;
          }
        },
        p(new_ctx, dirty) {
          ctx = new_ctx;
          if (dirty[0] & /*views*/1 && t0_value !== (t0_value = /*childView*/ctx[50].name + "")) set_data(t0, t0_value);
          if (addHref_action && is_function(addHref_action.update) && dirty[0] & /*views*/1) addHref_action.update.call(null, /*childView*/ctx[50].href);
          if (current_block_type === (current_block_type = select_block_type(ctx)) && if_block) {
            if_block.p(ctx, dirty);
          } else {
            if (if_block) if_block.d(1);
            if_block = current_block_type && current_block_type(ctx);
            if (if_block) {
              if_block.c();
              if_block.m(div2, t3);
            }
          }
          if (dirty[0] & /*views*/1 && div2_id_value !== (div2_id_value = "view-" + /*childView*/ctx[50].id)) {
            attr(div2, "id", div2_id_value);
          }
          if (dirty[0] & /*views, selectedId, selectedParentId*/11) {
            toggle_class(div2, "selected", /*childView*/ctx[50].id === /*selectedId*/ctx[1] || /*childView*/ctx[50].id === /*selectedParentId*/ctx[3]);
          }
        },
        d(detaching) {
          if (detaching) detach(div2);
          if (if_block) {
            if_block.d();
          }
          mounted = false;
          run_all(dispose);
        }
      };
    }

    // (13:6) {#each views as view (view.id)}
    function create_each_block(key_1, ctx) {
      let div3;
      let div0;
      let t0;
      let div2;
      let a;
      let t1;
      let t2;
      let div1;
      let t3_value = /*view*/ctx[47].name + "";
      let t3;
      let addHref_action;
      let t4;
      let t5;
      let t6;
      let div2_id_value;
      let t7;
      let t8;
      let current;
      let mounted;
      let dispose;
      let if_block0 = /*view*/ctx[47].icon && create_if_block_9(ctx);
      let if_block1 = (! /*view*/ctx[47].icon || !(/*view*/ctx[47].icon.svg || /*view*/ctx[47].icon.name || /*view*/ctx[47].icon.path || /*view*/ctx[47].icon.url)) && create_if_block_8();
      let if_block2 = /*view*/ctx[47].childViews.length > 0 && /*menuExpanded*/ctx[2] && create_if_block_7(ctx);
      let if_block3 = ! /*menuExpanded*/ctx[2] && /*showTooltips*/ctx[8] && ! /*isXS*/ctx[5] && create_if_block_6(ctx);
      let if_block4 = /*menuExpanded*/ctx[2] && /*view*/ctx[47].description && /*showTooltips*/ctx[8] && ! /*isXS*/ctx[5] && create_if_block_5(ctx);
      function click_handler(...args) {
        return /*click_handler*/ctx[37](/*view*/ctx[47], ...args);
      }
      let if_block5 = /*view*/ctx[47].childViews.length > 0 && /*view*/ctx[47].isExpanded && create_if_block_1(ctx);
      return {
        key: key_1,
        first: null,
        c() {
          div3 = element("div");
          div0 = element("div");
          t0 = space();
          div2 = element("div");
          a = element("a");
          if (if_block0) if_block0.c();
          t1 = space();
          if (if_block1) if_block1.c();
          t2 = space();
          div1 = element("div");
          t3 = text(t3_value);
          t4 = space();
          if (if_block2) if_block2.c();
          t5 = space();
          if (if_block3) if_block3.c();
          t6 = space();
          if (if_block4) if_block4.c();
          t7 = space();
          if (if_block5) if_block5.c();
          t8 = space();
          attr(div0, "class", "selected-indicator svelte-18b46lh");
          attr(div1, "pros-tooltip", "");
          attr(div1, "class", "view-name svelte-18b46lh");
          toggle_class(div1, "expanded", /*menuExpanded*/ctx[2]);
          attr(a, "class", "view-link svelte-18b46lh");
          attr(div2, "id", div2_id_value = "view-" + /*view*/ctx[47].id);
          attr(div2, "class", "view-content svelte-18b46lh");
          toggle_class(div2, "selected", /*view*/ctx[47].id === /*selectedId*/ctx[1] || ! /*view*/ctx[47].isExpanded && (/*view*/ctx[47].id === /*selectedParentId*/ctx[3] || /*view*/ctx[47].id === /*selectedGrandParentId*/ctx[4]));
          attr(div3, "class", "view-content-container svelte-18b46lh");
          this.first = div3;
        },
        m(target, anchor) {
          insert(target, div3, anchor);
          append(div3, div0);
          append(div3, t0);
          append(div3, div2);
          append(div2, a);
          if (if_block0) if_block0.m(a, null);
          append(a, t1);
          if (if_block1) if_block1.m(a, null);
          append(a, t2);
          append(a, div1);
          append(div1, t3);
          append(div2, t4);
          if (if_block2) if_block2.m(div2, null);
          append(div2, t5);
          if (if_block3) if_block3.m(div2, null);
          append(div2, t6);
          if (if_block4) if_block4.m(div2, null);
          append(div3, t7);
          if (if_block5) if_block5.m(div3, null);
          append(div3, t8);
          current = true;
          if (!mounted) {
            dispose = [action_destroyer(addHref_action = addHref.call(null, a, /*view*/ctx[47].href)), listen(div2, "click", click_handler)];
            mounted = true;
          }
        },
        p(new_ctx, dirty) {
          ctx = new_ctx;
          if (/*view*/ctx[47].icon) {
            if (if_block0) {
              if_block0.p(ctx, dirty);
              if (dirty[0] & /*views*/1) {
                transition_in(if_block0, 1);
              }
            } else {
              if_block0 = create_if_block_9(ctx);
              if_block0.c();
              transition_in(if_block0, 1);
              if_block0.m(a, t1);
            }
          } else if (if_block0) {
            group_outros();
            transition_out(if_block0, 1, 1, () => {
              if_block0 = null;
            });
            check_outros();
          }
          if (! /*view*/ctx[47].icon || !(/*view*/ctx[47].icon.svg || /*view*/ctx[47].icon.name || /*view*/ctx[47].icon.path || /*view*/ctx[47].icon.url)) {
            if (if_block1) ; else {
              if_block1 = create_if_block_8();
              if_block1.c();
              if_block1.m(a, t2);
            }
          } else if (if_block1) {
            if_block1.d(1);
            if_block1 = null;
          }
          if ((!current || dirty[0] & /*views*/1) && t3_value !== (t3_value = /*view*/ctx[47].name + "")) set_data(t3, t3_value);
          if (dirty[0] & /*menuExpanded*/4) {
            toggle_class(div1, "expanded", /*menuExpanded*/ctx[2]);
          }
          if (addHref_action && is_function(addHref_action.update) && dirty[0] & /*views*/1) addHref_action.update.call(null, /*view*/ctx[47].href);
          if (/*view*/ctx[47].childViews.length > 0 && /*menuExpanded*/ctx[2]) {
            if (if_block2) {
              if_block2.p(ctx, dirty);
            } else {
              if_block2 = create_if_block_7(ctx);
              if_block2.c();
              if_block2.m(div2, t5);
            }
          } else if (if_block2) {
            if_block2.d(1);
            if_block2 = null;
          }
          if (! /*menuExpanded*/ctx[2] && /*showTooltips*/ctx[8] && ! /*isXS*/ctx[5]) {
            if (if_block3) {
              if_block3.p(ctx, dirty);
            } else {
              if_block3 = create_if_block_6(ctx);
              if_block3.c();
              if_block3.m(div2, t6);
            }
          } else if (if_block3) {
            if_block3.d(1);
            if_block3 = null;
          }
          if (/*menuExpanded*/ctx[2] && /*view*/ctx[47].description && /*showTooltips*/ctx[8] && ! /*isXS*/ctx[5]) {
            if (if_block4) {
              if_block4.p(ctx, dirty);
            } else {
              if_block4 = create_if_block_5(ctx);
              if_block4.c();
              if_block4.m(div2, null);
            }
          } else if (if_block4) {
            if_block4.d(1);
            if_block4 = null;
          }
          if (!current || dirty[0] & /*views*/1 && div2_id_value !== (div2_id_value = "view-" + /*view*/ctx[47].id)) {
            attr(div2, "id", div2_id_value);
          }
          if (dirty[0] & /*views, selectedId, selectedParentId, selectedGrandParentId*/27) {
            toggle_class(div2, "selected", /*view*/ctx[47].id === /*selectedId*/ctx[1] || ! /*view*/ctx[47].isExpanded && (/*view*/ctx[47].id === /*selectedParentId*/ctx[3] || /*view*/ctx[47].id === /*selectedGrandParentId*/ctx[4]));
          }
          if (/*view*/ctx[47].childViews.length > 0 && /*view*/ctx[47].isExpanded) {
            if (if_block5) {
              if_block5.p(ctx, dirty);
              if (dirty[0] & /*views*/1) {
                transition_in(if_block5, 1);
              }
            } else {
              if_block5 = create_if_block_1(ctx);
              if_block5.c();
              transition_in(if_block5, 1);
              if_block5.m(div3, t8);
            }
          } else if (if_block5) {
            group_outros();
            transition_out(if_block5, 1, 1, () => {
              if_block5 = null;
            });
            check_outros();
          }
        },
        i(local) {
          if (current) return;
          transition_in(if_block0);
          transition_in(if_block5);
          current = true;
        },
        o(local) {
          transition_out(if_block0);
          transition_out(if_block5);
          current = false;
        },
        d(detaching) {
          if (detaching) detach(div3);
          if (if_block0) if_block0.d();
          if (if_block1) if_block1.d();
          if (if_block2) if_block2.d();
          if (if_block3) if_block3.d();
          if (if_block4) if_block4.d();
          if (if_block5) if_block5.d();
          mounted = false;
          run_all(dispose);
        }
      };
    }
    function create_fragment(ctx) {
      let if_block_anchor;
      let current;
      let if_block = /*views*/ctx[0] && /*views*/ctx[0].length > 0 && create_if_block(ctx);
      return {
        c() {
          if (if_block) if_block.c();
          if_block_anchor = empty();
        },
        m(target, anchor) {
          if (if_block) if_block.m(target, anchor);
          insert(target, if_block_anchor, anchor);
          current = true;
        },
        p(ctx, dirty) {
          if (/*views*/ctx[0] && /*views*/ctx[0].length > 0) {
            if (if_block) {
              if_block.p(ctx, dirty);
              if (dirty[0] & /*views*/1) {
                transition_in(if_block, 1);
              }
            } else {
              if_block = create_if_block(ctx);
              if_block.c();
              transition_in(if_block, 1);
              if_block.m(if_block_anchor.parentNode, if_block_anchor);
            }
          } else if (if_block) {
            group_outros();
            transition_out(if_block, 1, 1, () => {
              if_block = null;
            });
            check_outros();
          }
        },
        i(local) {
          if (current) return;
          transition_in(if_block);
          current = true;
        },
        o(local) {
          transition_out(if_block);
          current = false;
        },
        d(detaching) {
          if (if_block) if_block.d(detaching);
          if (detaching) detach(if_block_anchor);
        }
      };
    }
    function positionDescription(node) {
      let viewContent = node.closest(".view-content");
      let mouseEnterListener = () => {
        let viewContentRect = viewContent.getBoundingClientRect();
        node.style.top = `${viewContentRect.top}px`;

        // Set display here instead of in CSS to ensure positioning
        node.style.display = "inherit";
      };
      let mouseLeaveListener = () => {
        node.style.display = "";
      };
      viewContent.addEventListener("mouseenter", mouseEnterListener);
      viewContent.addEventListener("mouseleave", mouseLeaveListener);
      return {
        destroy() {
          viewContent.removeEventListener("mouseenter", mouseEnterListener);
          viewContent.removeEventListener("mouseleave", mouseLeaveListener);
        }
      };
    }

    // Sadly, need to add href conditionally since svelte doesn't yet remove undefined or false attributes.
    // See https://github.com/sveltejs/svelte/issues/1434
    function addHref(node, href) {
      if (href) {
        node.setAttribute("href", href);
      }
    }
    function fetchSVG(path) {
      return window.fetch(path).then(resp => resp.text());
    }
    function notEmpty(test) {
      return test !== undefined && test !== null && test.trim() !== "";
    }
    function instance($$self, $$props, $$invalidate) {
      const dispatch = createEventDispatcher();
      let {
        menuExpanded = false
      } = $$props;
      let {
        views = []
      } = $$props;
      let {
        selectedId = null
      } = $$props;
      let {
        selectedParentId = null
      } = $$props;
      let {
        selectedGrandParentId = null
      } = $$props;
      let {
        isXS = false
      } = $$props;
      let {
        responsiveExpanded = false
      } = $$props;
      let {
        resizeListener = null
      } = $$props;
      let {
        toggleListener = null
      } = $$props;
      let {
        hideNav = false
      } = $$props;
      let {
        timeoutId = null
      } = $$props;
      let {
        showTooltips = true
      } = $$props;
      let {
        viewName = null
      } = $$props;
      let {
        _themeEventListener
      } = $$props;
      let {
        _shapeEventListener
      } = $$props;
      let {
        _densityEventListener
      } = $$props;
      let {
        _theme
      } = $$props;
      let {
        _shape
      } = $$props;
      let {
        _density
      } = $$props;
      let {
        _lastTheme
      } = $$props;
      let {
        _lastShape
      } = $$props;
      let {
        _lastDensity
      } = $$props;
      let selectIdOld = null;
      let {
        theme
      } = $$props; // Color Theme (auto/dark/light)
      let {
        shape
      } = $$props; // Shape Mode (round/sharp)
      let {
        density
      } = $$props; // Density Mode (standard/high)
      let {
        _suppressExpand = false
      } = $$props;

      //Lifecycle (Svelte methods)
      onMount(() => {
        $$invalidate(21, toggleListener = toggleResponsive.bind(this));
        window.addEventListener("posb-view-nav-toggle-clicked", toggleListener);
      });
      beforeUpdate(() => {
        $$invalidate(29, theme = notEmpty(theme) ? theme : "light");
        $$invalidate(30, shape = notEmpty(shape) ? shape : "round");
        $$invalidate(31, density = notEmpty(density) ? density : "standard");
        if (theme !== _lastTheme) {
          $$invalidate(26, _lastTheme = theme);
          if (theme === "auto") {
            let themeAttribute = window.document.body.getAttribute("pos--theme");
            $$invalidate(9, _theme = themeAttribute ? themeAttribute : "light");
            if (!_themeEventListener) {
              // Only start listening once
              $$invalidate(23, _themeEventListener = window.addEventListener("posh-theme-changed", event => {
                if (theme === "auto") {
                  $$invalidate(9, _theme = event.detail.theme);
                }
              }));
            }
          } else {
            $$invalidate(9, _theme = theme);
          }
        }
        if (shape !== _lastShape) {
          $$invalidate(27, _lastShape = shape);
          if (shape === "auto") {
            let themeAttribute = window.document.body.getAttribute("pos--shape");
            $$invalidate(10, _shape = themeAttribute ? themeAttribute : "round");
            if (!_shapeEventListener) {
              // Only start listening once
              $$invalidate(24, _shapeEventListener = window.addEventListener("posh-shape-changed", event => {
                if (shape === "auto") {
                  $$invalidate(10, _shape = event.detail.shape);
                }
              }));
            }
          } else {
            $$invalidate(10, _shape = shape);
          }
        }
        if (density !== _lastDensity) {
          $$invalidate(28, _lastDensity = density);
          if (density === "auto") {
            let themeAttribute = window.document.body.getAttribute("pos--density");
            $$invalidate(11, _density = themeAttribute ? themeAttribute : "standard");
            if (!_densityEventListener) {
              // Only start listening once
              $$invalidate(25, _densityEventListener = window.addEventListener("posh-density-changed", event => {
                if (density === "auto") {
                  $$invalidate(11, _density = event.detail.density);
                }
              }));
            }
          } else {
            $$invalidate(11, _density = density);
          }
        }
      });
      onDestroy(() => {
        window.removeEventListener("resize", resizeListener);
        window.removeEventListener("posb-viewnav-toggle-clicked", toggleListener);
        if (_themeEventListener) {
          window.removeEventListener("posh-theme-changed", _themeEventListener);
        }
        if (_shapeEventListener) {
          window.removeEventListener("posh-shape-changed", _shapeEventListener);
        }
        if (_densityEventListener) {
          window.removeEventListener("posh-density-changed", _densityEventListener);
        }
      });

      //Methods
      function handleMouseOver(event) {
        $$invalidate(8, showTooltips = true);
        if (menuExpanded) {
          return;
        }
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        $$invalidate(7, timeoutId = setTimeout(() => {
          $$invalidate(2, menuExpanded = true);
          $$invalidate(7, timeoutId = null);
        }, 2000));
      }
      function handleMouseLeave(event) {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        collapseAllSubViews.call(this);
        $$invalidate(7, timeoutId = null);
        $$invalidate(2, menuExpanded = false);
      }
      function hideTooltips() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        $$invalidate(8, showTooltips = false);
      }
      function hideAndCollapse() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        collapseAllSubViews.call(this);
        $$invalidate(8, showTooltips = false);
        $$invalidate(2, menuExpanded = false);
      }
      function toggleResponsive() {
        $$invalidate(6, responsiveExpanded = !responsiveExpanded);
      }
      function expandNav(event) {
        if (timeoutId) {
          clearTimeout(timeoutId);
          $$invalidate(7, timeoutId = null);
        }
        if (_suppressExpand) {
          $$invalidate(32, _suppressExpand = false);
        } else {
          //views = views;
          $$invalidate(2, menuExpanded = true);
        }
      }
      function viewClicked(event, view) {
        $$invalidate(32, _suppressExpand = true);

        // event.stopPropagation();
        if (timeoutId) {
          clearTimeout(timeoutId);
          $$invalidate(7, timeoutId = null);
        }
        if (view.childViews && view.childViews.length > 0) {
          $$invalidate(0, views = views.map(v => {
            if (view.id === v.id) {
              v.isExpanded = !v.isExpanded;
            }
            return v;
          }));
          $$invalidate(2, menuExpanded = true);
          event.preventDefault();
          return;
        }
        collapseAllSubViews.call(this);
        $$invalidate(8, showTooltips = false);
        $$invalidate(2, menuExpanded = false);
        $$invalidate(6, responsiveExpanded = false);

        // Adapted from vue-router: https://github.com/vuejs/vue-router/blob/dev/src/components/link.js#L105-L122
        // don't redirect with control keys
        if (event.metaKey || event.altKey || event.ctrlKey || event.shiftKey) {
          return;
        }

        // don't redirect when preventDefault called
        if (event.defaultPrevented) {
          return;
        }

        // don't redirect on right click
        if (event.button !== undefined && event.button !== 0) {
          return;
        }

        // don't redirect if `target="_blank"`
        if (event.currentTarget && event.currentTarget.getAttribute) {
          const target = event.currentTarget.getAttribute("target");
          if (/\b_blank\b/i.test(target)) {
            return;
          }
        }
        $$invalidate(1, selectedId = view.id);
        dispatch("viewClicked", {
          event,
          view
        });
      }
      function updateSelection() {
        if (!selectedId || views.length === 0) {
          return;
        }
        $$invalidate(3, selectedParentId = null);
        $$invalidate(4, selectedGrandParentId = null);
        let selectedView = views.find(view => {
          return view.id === selectedId;
        });
        if (selectedView) {
          $$invalidate(3, selectedParentId = selectedView.id);
        } else {
          for (let i = 0; i < views.length; i++) {
            if (!views[i].children) {
              continue;
            }
            for (let j = 0; j < views[i].children.length; j++) {
              let childView = views[i].children[j];
              if (childView.id === selectedId) {
                $$invalidate(3, selectedParentId = views[i].id);
                break;
              } else {
                if (childView.children) {
                  let grandChild = childView.children.find(g => {
                    return g.id === selectedId;
                  });
                  if (grandChild) {
                    $$invalidate(3, selectedParentId = childView.id);
                    $$invalidate(4, selectedGrandParentId = views[i].id);
                    break;
                  }
                }
              }
            }
          }
        }
      }

      //Transitions
      function slideRight(node, {
        delay = 0,
        duration = 250,
        easing = cubicOut$1
      }) {
        const style = window.getComputedStyle(node);
        const width = window.parseFloat(style.width);
        return {
          delay,
          duration,
          css(t) {
            return `width: ${t * width}px;`;
          }
        };
      }

      //Other functions
      function handleWindowResize() {
        $$invalidate(5, isXS = window.innerWidth < 600);
        set(window, "printos.blue.ui.responsiveMenu", isXS);
      }
      function collapseAllSubViews() {
        $$invalidate(0, views = views.map(view => {
          if (view.childViews && view.childViews.length > 0) {
            view.isExpanded = false;
          }
          return view;
        }));
      }
      function icon_name_binding(value, view) {
        if ($$self.$$.not_equal(view.icon.name, value)) {
          view.icon.name = value;
          $$invalidate(0, views), $$invalidate(33, selectIdOld), $$invalidate(1, selectedId), $$invalidate(20, resizeListener);
        }
      }
      function icon_path_binding(value, view) {
        if ($$self.$$.not_equal(view.icon.path, value)) {
          view.icon.path = value;
          $$invalidate(0, views), $$invalidate(33, selectIdOld), $$invalidate(1, selectedId), $$invalidate(20, resizeListener);
        }
      }
      function icon_url_binding(value, view) {
        if ($$self.$$.not_equal(view.icon.url, value)) {
          view.icon.url = value;
          $$invalidate(0, views), $$invalidate(33, selectIdOld), $$invalidate(1, selectedId), $$invalidate(20, resizeListener);
        }
      }
      const click_handler = (view, event) => viewClicked(event, view);
      const click_handler_1 = (childView, event) => viewClicked(event, childView);
      $$self.$$set = $$props => {
        if ("menuExpanded" in $$props) $$invalidate(2, menuExpanded = $$props.menuExpanded);
        if ("views" in $$props) $$invalidate(0, views = $$props.views);
        if ("selectedId" in $$props) $$invalidate(1, selectedId = $$props.selectedId);
        if ("selectedParentId" in $$props) $$invalidate(3, selectedParentId = $$props.selectedParentId);
        if ("selectedGrandParentId" in $$props) $$invalidate(4, selectedGrandParentId = $$props.selectedGrandParentId);
        if ("isXS" in $$props) $$invalidate(5, isXS = $$props.isXS);
        if ("responsiveExpanded" in $$props) $$invalidate(6, responsiveExpanded = $$props.responsiveExpanded);
        if ("resizeListener" in $$props) $$invalidate(20, resizeListener = $$props.resizeListener);
        if ("toggleListener" in $$props) $$invalidate(21, toggleListener = $$props.toggleListener);
        if ("hideNav" in $$props) $$invalidate(12, hideNav = $$props.hideNav);
        if ("timeoutId" in $$props) $$invalidate(7, timeoutId = $$props.timeoutId);
        if ("showTooltips" in $$props) $$invalidate(8, showTooltips = $$props.showTooltips);
        if ("viewName" in $$props) $$invalidate(22, viewName = $$props.viewName);
        if ("_themeEventListener" in $$props) $$invalidate(23, _themeEventListener = $$props._themeEventListener);
        if ("_shapeEventListener" in $$props) $$invalidate(24, _shapeEventListener = $$props._shapeEventListener);
        if ("_densityEventListener" in $$props) $$invalidate(25, _densityEventListener = $$props._densityEventListener);
        if ("_theme" in $$props) $$invalidate(9, _theme = $$props._theme);
        if ("_shape" in $$props) $$invalidate(10, _shape = $$props._shape);
        if ("_density" in $$props) $$invalidate(11, _density = $$props._density);
        if ("_lastTheme" in $$props) $$invalidate(26, _lastTheme = $$props._lastTheme);
        if ("_lastShape" in $$props) $$invalidate(27, _lastShape = $$props._lastShape);
        if ("_lastDensity" in $$props) $$invalidate(28, _lastDensity = $$props._lastDensity);
        if ("theme" in $$props) $$invalidate(29, theme = $$props.theme);
        if ("shape" in $$props) $$invalidate(30, shape = $$props.shape);
        if ("density" in $$props) $$invalidate(31, density = $$props.density);
        if ("_suppressExpand" in $$props) $$invalidate(32, _suppressExpand = $$props._suppressExpand);
      };
      $$self.$$.update = () => {
        if ($$self.$$.dirty[0] & /*selectedId, views, resizeListener*/1048579 | $$self.$$.dirty[1] & /*selectIdOld*/4) {
          {
            //Onstate changes
            if (selectIdOld !== selectedId) {
              $$invalidate(33, selectIdOld = selectedId);
              updateSelection();
            }
            if (views && views.length > 0) {
              // get expanded preferences let expandedPreferences = get(preferences, 'orgId.appId.viewNav.expanded', []);
              views.forEach(view => {
                view.childViews = [];
                if (view.icon && view.icon.svgPath && !view.icon.svg && !view.icon.fetching) {
                  view.icon.fetching = true;
                  fetchSVG.call(this, view.icon.svgPath).then(svg => {
                    view.icon.fetching = false;
                    view.icon.svg = svg;

                    // Note: this forces Svelte to invalidate the views object where just updating an inner property does not
                    $$invalidate(0, views = views.slice());
                  });
                }
                if (view.children) {
                  view.children.forEach(childView => {
                    let showInNav = get(childView, "showInNav", true);
                    if (showInNav) {
                      view.childViews.push(childView);
                    }
                  });
                }
              }); // If expandedPreferences.contains(view.id) then view.isExpanded = true;

              if (!resizeListener) {
                $$invalidate(20, resizeListener = handleWindowResize.bind(this));
                handleWindowResize.call(this);
                window.addEventListener("resize", resizeListener);
              }
              updateSelection();
            }
          }
        }
      };
      $$invalidate(22, viewName = ({
        selectedId,
        views
      }) => {
        if (!selectedId) {
          return "";
        }
        let selectedView = views.find(view => {
          return view.id === selectedId;
        });
        if (!selectedView) {
          for (let i = 0; i < views.length; i++) {
            if (!views[i].children) {
              continue;
            }
            selectedView = views[i].children.find(childView => {
              return childView.id === selectedId;
            });
            if (selectedView) {
              break;
            }
          }
        }
        return selectedView ? selectedView.name : "";
      });
      return [views, selectedId, menuExpanded, selectedParentId, selectedGrandParentId, isXS, responsiveExpanded, timeoutId, showTooltips, _theme, _shape, _density, hideNav, viewClicked, handleMouseOver, handleMouseLeave, hideTooltips, hideAndCollapse, expandNav, slideRight, resizeListener, toggleListener, viewName, _themeEventListener, _shapeEventListener, _densityEventListener, _lastTheme, _lastShape, _lastDensity, theme, shape, density, _suppressExpand, selectIdOld, icon_name_binding, icon_path_binding, icon_url_binding, click_handler, click_handler_1];
    }
    class ViewNav extends SvelteComponent {
      constructor(options) {
        super();
        if (!document.getElementById("svelte-18b46lh-style")) add_css();
        init(this, options, instance, create_fragment, safe_not_equal, {
          menuExpanded: 2,
          views: 0,
          selectedId: 1,
          selectedParentId: 3,
          selectedGrandParentId: 4,
          isXS: 5,
          responsiveExpanded: 6,
          resizeListener: 20,
          toggleListener: 21,
          hideNav: 12,
          timeoutId: 7,
          showTooltips: 8,
          viewName: 22,
          _themeEventListener: 23,
          _shapeEventListener: 24,
          _densityEventListener: 25,
          _theme: 9,
          _shape: 10,
          _density: 11,
          _lastTheme: 26,
          _lastShape: 27,
          _lastDensity: 28,
          theme: 29,
          shape: 30,
          density: 31,
          _suppressExpand: 32,
          viewClicked: 13
        }, [-1, -1]);
      }
      get viewClicked() {
        return this.$$.ctx[13];
      }
    }

    exports.ViewNav = ViewNav;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
